"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * User Management Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UsersServiceApi = exports.UsersServiceApiFactory = exports.UsersServiceApiFp = exports.UsersServiceApiAxiosParamCreator = exports.TokensServiceApi = exports.TokensServiceApiFactory = exports.TokensServiceApiFp = exports.TokensServiceApiAxiosParamCreator = exports.RolesServiceApi = exports.RolesServiceApiFactory = exports.RolesServiceApiFp = exports.RolesServiceApiAxiosParamCreator = exports.ResellerCustomersServiceApi = exports.ResellerCustomersServiceApiFactory = exports.ResellerCustomersServiceApiFp = exports.ResellerCustomersServiceApiAxiosParamCreator = exports.OnboardingServiceApi = exports.OnboardingServiceApiFactory = exports.OnboardingServiceApiFp = exports.OnboardingServiceApiAxiosParamCreator = exports.OfflineTasksServiceApi = exports.OfflineTasksServiceApiFactory = exports.OfflineTasksServiceApiFp = exports.OfflineTasksServiceApiAxiosParamCreator = exports.MigrationServiceApi = exports.MigrationServiceApiFactory = exports.MigrationServiceApiFp = exports.MigrationServiceApiAxiosParamCreator = exports.EntitiesSharingServiceApi = exports.EntitiesSharingServiceApiFactory = exports.EntitiesSharingServiceApiFp = exports.EntitiesSharingServiceApiAxiosParamCreator = exports.AuthorizationServiceApi = exports.AuthorizationServiceApiFactory = exports.AuthorizationServiceApiFp = exports.AuthorizationServiceApiAxiosParamCreator = exports.AuthenticationServiceApi = exports.AuthenticationServiceApiFactory = exports.AuthenticationServiceApiFp = exports.AuthenticationServiceApiAxiosParamCreator = exports.OrganizationEntityCategory = exports.HierarchicalEntityCategory = exports.DateFilterType = exports.CategoryActionPermission = exports.CategoryAction = exports.Action = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 *
 * @export
 * @enum {string}
 */
exports.Action = {
    List: 'LIST',
    View: 'VIEW',
    Update: 'UPDATE',
    Impersonate: 'IMPERSONATE',
    ExecOfflineTasksAs: 'EXEC_OFFLINE_TASKS_AS'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CategoryAction = {
    Create: 'CREATE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.CategoryActionPermission = {
    Full: 'FULL',
    Partial: 'PARTIAL',
    None: 'NONE'
};
/**
 *
 * @export
 * @enum {string}
 */
exports.DateFilterType = {
    Equals: 'EQUALS',
    NotEquals: 'NOT_EQUALS',
    GreaterThan: 'GREATER_THAN',
    GreaterThanOrEquals: 'GREATER_THAN_OR_EQUALS',
    LessThan: 'LESS_THAN',
    LessThanOrEquals: 'LESS_THAN_OR_EQUALS'
};
/**
 * Categories in which the account could be part of the resource path in KC
 * @export
 * @enum {string}
 */
exports.HierarchicalEntityCategory = {
    Accounts: 'ACCOUNTS',
    DataAccess: 'DATA_ACCESS',
    Commitments: 'COMMITMENTS',
    Budgets: 'BUDGETS',
    Dashboards: 'DASHBOARDS',
    Reports: 'REPORTS',
    Alerts: 'ALERTS'
};
/**
 * Categories that can only be assigned to an organization level. system_management is relevant ony for Anodot realm. reseller_customers is relevant only for reseller realms.
 * @export
 * @enum {string}
 */
exports.OrganizationEntityCategory = {
    OrganizationManagement: 'ORGANIZATION_MANAGEMENT',
    Roles: 'ROLES',
    UsersManagement: 'USERS_MANAGEMENT',
    CostCenters: 'COST_CENTERS',
    ResellerCustomers: 'RESELLER_CUSTOMERS',
    CostAllocation: 'COST_ALLOCATION',
    SystemManagement: 'SYSTEM_MANAGEMENT',
    Recommendations: 'RECOMMENDATIONS',
    ResellerUsersPreRebillingDataAccess: 'RESELLER_USERS_PRE_REBILLING_DATA_ACCESS'
};
/**
 * AuthenticationServiceApi - axios parameter creator
 * @export
 */
var AuthenticationServiceApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get the details of the current logged in user
         * @summary Get current user details
         * @param {string} accessToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser: function (accessToken_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1], args_1, true), void 0, function (accessToken, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('getCurrentUser', 'accessToken', accessToken);
                    localVarPath = "/api/v1/me";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get the organization for which this user is a member
         * @summary Get organization of the user
         * @param {string} username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserOrgId: function (username_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([username_1], args_1, true), void 0, function (username, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'username' is not null or undefined
                    (0, common_1.assertParamExists)('getUserOrgId', 'username', username);
                    localVarPath = "/api/v1/{username}/org-id"
                        .replace("{".concat("username", "}"), encodeURIComponent(String(username)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.AuthenticationServiceApiAxiosParamCreator = AuthenticationServiceApiAxiosParamCreator;
/**
 * AuthenticationServiceApi - functional programming interface
 * @export
 */
var AuthenticationServiceApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AuthenticationServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get the details of the current logged in user
         * @summary Get current user details
         * @param {string} accessToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser: function (accessToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCurrentUser(accessToken, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthenticationServiceApi.getCurrentUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get the organization for which this user is a member
         * @summary Get organization of the user
         * @param {string} username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserOrgId: function (username, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getUserOrgId(username, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthenticationServiceApi.getUserOrgId']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.AuthenticationServiceApiFp = AuthenticationServiceApiFp;
/**
 * AuthenticationServiceApi - factory interface
 * @export
 */
var AuthenticationServiceApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AuthenticationServiceApiFp)(configuration);
    return {
        /**
         * Get the details of the current logged in user
         * @summary Get current user details
         * @param {AuthenticationServiceApiGetCurrentUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUser: function (requestParameters, options) {
            return localVarFp.getCurrentUser(requestParameters.accessToken, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the organization for which this user is a member
         * @summary Get organization of the user
         * @param {AuthenticationServiceApiGetUserOrgIdRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserOrgId: function (requestParameters, options) {
            return localVarFp.getUserOrgId(requestParameters.username, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AuthenticationServiceApiFactory = AuthenticationServiceApiFactory;
/**
 * AuthenticationServiceApi - object-oriented interface
 * @export
 * @class AuthenticationServiceApi
 * @extends {BaseAPI}
 */
var AuthenticationServiceApi = /** @class */ (function (_super) {
    __extends(AuthenticationServiceApi, _super);
    function AuthenticationServiceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get the details of the current logged in user
     * @summary Get current user details
     * @param {AuthenticationServiceApiGetCurrentUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationServiceApi
     */
    AuthenticationServiceApi.prototype.getCurrentUser = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AuthenticationServiceApiFp)(this.configuration).getCurrentUser(requestParameters.accessToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the organization for which this user is a member
     * @summary Get organization of the user
     * @param {AuthenticationServiceApiGetUserOrgIdRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthenticationServiceApi
     */
    AuthenticationServiceApi.prototype.getUserOrgId = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AuthenticationServiceApiFp)(this.configuration).getUserOrgId(requestParameters.username, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AuthenticationServiceApi;
}(base_1.BaseAPI));
exports.AuthenticationServiceApi = AuthenticationServiceApi;
/**
 * AuthorizationServiceApi - axios parameter creator
 * @export
 */
var AuthorizationServiceApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * This API is intended to be used in order to resolve the accessible menu items. It receives either a list of categories or empty list to fetch all categories and list of actions per category or none to check for any available permission. The response of the API is a list of accessible categories. If the requesting user is a reseller user accessing a customer organization, the targetOrgToken header should include the exchanged token for this customer. If the requesting user is a customer - the request body should include all reseller tokens.
         * @summary Get all categories the user is authorized to access with at least one permission
         * @param {string} accessToken
         * @param {string} [targetOrgToken]
         * @param {AccessibleCategoriesRequest} [accessibleCategoriesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessibleCategories: function (accessToken_1, targetOrgToken_1, accessibleCategoriesRequest_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, targetOrgToken_1, accessibleCategoriesRequest_1], args_1, true), void 0, function (accessToken, targetOrgToken, accessibleCategoriesRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('getAccessibleCategories', 'accessToken', accessToken);
                    localVarPath = "/api/v1/get-accessible-categories";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accessibleCategoriesRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all categories the user is authorized to access with at least one permission, and the allowed actions for each category
         * @summary Get the categories and actions that the user is authorized to access
         * @param {string} accessToken
         * @param {AccessibleCategoriesRequest} accessibleCategoriesRequest
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessibleCategoriesAndActions: function (accessToken_1, accessibleCategoriesRequest_1, targetOrgToken_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, accessibleCategoriesRequest_1, targetOrgToken_1], args_1, true), void 0, function (accessToken, accessibleCategoriesRequest, targetOrgToken, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('getAccessibleCategoriesAndActions', 'accessToken', accessToken);
                    // verify required parameter 'accessibleCategoriesRequest' is not null or undefined
                    (0, common_1.assertParamExists)('getAccessibleCategoriesAndActions', 'accessibleCategoriesRequest', accessibleCategoriesRequest);
                    localVarPath = "/api/v1/get-accessible-categories-and-actions";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accessibleCategoriesRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         *
         * @summary Get data entities accessible to the user
         * @param {string} accessToken
         * @param {string} [targetOrgToken]
         * @param {boolean} [includeLinkedAccounts] If true, the response will include also the actual linked accounts represented by the data role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessibleDataEntities: function (accessToken_1, targetOrgToken_1, includeLinkedAccounts_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, targetOrgToken_1, includeLinkedAccounts_1], args_1, true), void 0, function (accessToken, targetOrgToken, includeLinkedAccounts, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('getAccessibleDataEntities', 'accessToken', accessToken);
                    localVarPath = "/api/v1/get-accessible-data-entities";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (includeLinkedAccounts !== undefined) {
                        localVarQueryParameter['includeLinkedAccounts'] = includeLinkedAccounts;
                    }
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all the entities the user is authorized to do the given actions on, for the given category. The access token header should include the login token for the requesting user. To get the entities of the current organization only - send just the AccessToken header. To get the entities of a customer only, send the AccessToken and the TargetOrgToken headers, where the TargetOrgToken has the customer\'s exchange token. To get the entities of the current organization AND its resellers, send the AccessToken header, and in the body include all the resellers tokens.
         * @summary Get all entities the user is authorized to do the given actions on, for the given category
         * @param {string} accessToken
         * @param {GetAuthorizedEntitiesRequest} getAuthorizedEntitiesRequest
         * @param {string} [targetOrgToken]
         * @param {string} [paginationToken] The token received in the previous response. if this is the first request - omit.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorizedEntities: function (accessToken_1, getAuthorizedEntitiesRequest_1, targetOrgToken_1, paginationToken_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, getAuthorizedEntitiesRequest_1, targetOrgToken_1, paginationToken_1], args_1, true), void 0, function (accessToken, getAuthorizedEntitiesRequest, targetOrgToken, paginationToken, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('getAuthorizedEntities', 'accessToken', accessToken);
                    // verify required parameter 'getAuthorizedEntitiesRequest' is not null or undefined
                    (0, common_1.assertParamExists)('getAuthorizedEntities', 'getAuthorizedEntitiesRequest', getAuthorizedEntitiesRequest);
                    localVarPath = "/api/v1/get-authorized-entities";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationToken !== undefined) {
                        localVarQueryParameter['paginationToken'] = paginationToken;
                    }
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(getAuthorizedEntitiesRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Check if the user is authorized to do all the given actions for all the given entities. If yes, returns a token that expresses that what was requested is actually allowed. The access token header should include the login token for the requesting user. In case the owner organization of the required resources is not the user\'s organization, the TargetTokenOrgHeader should include the exchange token for this organization.
         * @summary check all permissions
         * @param {string} accessToken
         * @param {string} [targetOrgToken]
         * @param {IsAuthorizedRequest} [isAuthorizedRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isAuthorized: function (accessToken_1, targetOrgToken_1, isAuthorizedRequest_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, targetOrgToken_1, isAuthorizedRequest_1], args_1, true), void 0, function (accessToken, targetOrgToken, isAuthorizedRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('isAuthorized', 'accessToken', accessToken);
                    localVarPath = "/api/v1/is-authorized";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(isAuthorizedRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * For every category, check that the user is allowed to do all the required actions on at least one entity with at least one of the tokens. If the requesting user is a reseller user accessing a customer organization, the targetOrgToken header should include the exchanged token for this customer. If the requesting user is a customer - the request body should include all reseller tokens.
         * @summary check minimal permissions for all categories and actions
         * @param {string} accessToken
         * @param {string} [targetOrgToken]
         * @param {AccessibleCategoriesRequest} [accessibleCategoriesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isAuthorizedForCategories: function (accessToken_1, targetOrgToken_1, accessibleCategoriesRequest_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, targetOrgToken_1, accessibleCategoriesRequest_1], args_1, true), void 0, function (accessToken, targetOrgToken, accessibleCategoriesRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('isAuthorizedForCategories', 'accessToken', accessToken);
                    localVarPath = "/api/v1/is-authorized-for-categories";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(accessibleCategoriesRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.AuthorizationServiceApiAxiosParamCreator = AuthorizationServiceApiAxiosParamCreator;
/**
 * AuthorizationServiceApi - functional programming interface
 * @export
 */
var AuthorizationServiceApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.AuthorizationServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         * This API is intended to be used in order to resolve the accessible menu items. It receives either a list of categories or empty list to fetch all categories and list of actions per category or none to check for any available permission. The response of the API is a list of accessible categories. If the requesting user is a reseller user accessing a customer organization, the targetOrgToken header should include the exchanged token for this customer. If the requesting user is a customer - the request body should include all reseller tokens.
         * @summary Get all categories the user is authorized to access with at least one permission
         * @param {string} accessToken
         * @param {string} [targetOrgToken]
         * @param {AccessibleCategoriesRequest} [accessibleCategoriesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessibleCategories: function (accessToken, targetOrgToken, accessibleCategoriesRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAccessibleCategories(accessToken, targetOrgToken, accessibleCategoriesRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthorizationServiceApi.getAccessibleCategories']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get all categories the user is authorized to access with at least one permission, and the allowed actions for each category
         * @summary Get the categories and actions that the user is authorized to access
         * @param {string} accessToken
         * @param {AccessibleCategoriesRequest} accessibleCategoriesRequest
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessibleCategoriesAndActions: function (accessToken, accessibleCategoriesRequest, targetOrgToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAccessibleCategoriesAndActions(accessToken, accessibleCategoriesRequest, targetOrgToken, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthorizationServiceApi.getAccessibleCategoriesAndActions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get data entities accessible to the user
         * @param {string} accessToken
         * @param {string} [targetOrgToken]
         * @param {boolean} [includeLinkedAccounts] If true, the response will include also the actual linked accounts represented by the data role
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessibleDataEntities: function (accessToken, targetOrgToken, includeLinkedAccounts, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAccessibleDataEntities(accessToken, targetOrgToken, includeLinkedAccounts, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthorizationServiceApi.getAccessibleDataEntities']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get all the entities the user is authorized to do the given actions on, for the given category. The access token header should include the login token for the requesting user. To get the entities of the current organization only - send just the AccessToken header. To get the entities of a customer only, send the AccessToken and the TargetOrgToken headers, where the TargetOrgToken has the customer\'s exchange token. To get the entities of the current organization AND its resellers, send the AccessToken header, and in the body include all the resellers tokens.
         * @summary Get all entities the user is authorized to do the given actions on, for the given category
         * @param {string} accessToken
         * @param {GetAuthorizedEntitiesRequest} getAuthorizedEntitiesRequest
         * @param {string} [targetOrgToken]
         * @param {string} [paginationToken] The token received in the previous response. if this is the first request - omit.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorizedEntities: function (accessToken, getAuthorizedEntitiesRequest, targetOrgToken, paginationToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAuthorizedEntities(accessToken, getAuthorizedEntitiesRequest, targetOrgToken, paginationToken, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthorizationServiceApi.getAuthorizedEntities']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Check if the user is authorized to do all the given actions for all the given entities. If yes, returns a token that expresses that what was requested is actually allowed. The access token header should include the login token for the requesting user. In case the owner organization of the required resources is not the user\'s organization, the TargetTokenOrgHeader should include the exchange token for this organization.
         * @summary check all permissions
         * @param {string} accessToken
         * @param {string} [targetOrgToken]
         * @param {IsAuthorizedRequest} [isAuthorizedRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isAuthorized: function (accessToken, targetOrgToken, isAuthorizedRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.isAuthorized(accessToken, targetOrgToken, isAuthorizedRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthorizationServiceApi.isAuthorized']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * For every category, check that the user is allowed to do all the required actions on at least one entity with at least one of the tokens. If the requesting user is a reseller user accessing a customer organization, the targetOrgToken header should include the exchanged token for this customer. If the requesting user is a customer - the request body should include all reseller tokens.
         * @summary check minimal permissions for all categories and actions
         * @param {string} accessToken
         * @param {string} [targetOrgToken]
         * @param {AccessibleCategoriesRequest} [accessibleCategoriesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isAuthorizedForCategories: function (accessToken, targetOrgToken, accessibleCategoriesRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.isAuthorizedForCategories(accessToken, targetOrgToken, accessibleCategoriesRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['AuthorizationServiceApi.isAuthorizedForCategories']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.AuthorizationServiceApiFp = AuthorizationServiceApiFp;
/**
 * AuthorizationServiceApi - factory interface
 * @export
 */
var AuthorizationServiceApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.AuthorizationServiceApiFp)(configuration);
    return {
        /**
         * This API is intended to be used in order to resolve the accessible menu items. It receives either a list of categories or empty list to fetch all categories and list of actions per category or none to check for any available permission. The response of the API is a list of accessible categories. If the requesting user is a reseller user accessing a customer organization, the targetOrgToken header should include the exchanged token for this customer. If the requesting user is a customer - the request body should include all reseller tokens.
         * @summary Get all categories the user is authorized to access with at least one permission
         * @param {AuthorizationServiceApiGetAccessibleCategoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessibleCategories: function (requestParameters, options) {
            return localVarFp.getAccessibleCategories(requestParameters.accessToken, requestParameters.targetOrgToken, requestParameters.accessibleCategoriesRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all categories the user is authorized to access with at least one permission, and the allowed actions for each category
         * @summary Get the categories and actions that the user is authorized to access
         * @param {AuthorizationServiceApiGetAccessibleCategoriesAndActionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessibleCategoriesAndActions: function (requestParameters, options) {
            return localVarFp.getAccessibleCategoriesAndActions(requestParameters.accessToken, requestParameters.accessibleCategoriesRequest, requestParameters.targetOrgToken, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get data entities accessible to the user
         * @param {AuthorizationServiceApiGetAccessibleDataEntitiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAccessibleDataEntities: function (requestParameters, options) {
            return localVarFp.getAccessibleDataEntities(requestParameters.accessToken, requestParameters.targetOrgToken, requestParameters.includeLinkedAccounts, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all the entities the user is authorized to do the given actions on, for the given category. The access token header should include the login token for the requesting user. To get the entities of the current organization only - send just the AccessToken header. To get the entities of a customer only, send the AccessToken and the TargetOrgToken headers, where the TargetOrgToken has the customer\'s exchange token. To get the entities of the current organization AND its resellers, send the AccessToken header, and in the body include all the resellers tokens.
         * @summary Get all entities the user is authorized to do the given actions on, for the given category
         * @param {AuthorizationServiceApiGetAuthorizedEntitiesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAuthorizedEntities: function (requestParameters, options) {
            return localVarFp.getAuthorizedEntities(requestParameters.accessToken, requestParameters.getAuthorizedEntitiesRequest, requestParameters.targetOrgToken, requestParameters.paginationToken, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Check if the user is authorized to do all the given actions for all the given entities. If yes, returns a token that expresses that what was requested is actually allowed. The access token header should include the login token for the requesting user. In case the owner organization of the required resources is not the user\'s organization, the TargetTokenOrgHeader should include the exchange token for this organization.
         * @summary check all permissions
         * @param {AuthorizationServiceApiIsAuthorizedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isAuthorized: function (requestParameters, options) {
            return localVarFp.isAuthorized(requestParameters.accessToken, requestParameters.targetOrgToken, requestParameters.isAuthorizedRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * For every category, check that the user is allowed to do all the required actions on at least one entity with at least one of the tokens. If the requesting user is a reseller user accessing a customer organization, the targetOrgToken header should include the exchanged token for this customer. If the requesting user is a customer - the request body should include all reseller tokens.
         * @summary check minimal permissions for all categories and actions
         * @param {AuthorizationServiceApiIsAuthorizedForCategoriesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isAuthorizedForCategories: function (requestParameters, options) {
            return localVarFp.isAuthorizedForCategories(requestParameters.accessToken, requestParameters.targetOrgToken, requestParameters.accessibleCategoriesRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.AuthorizationServiceApiFactory = AuthorizationServiceApiFactory;
/**
 * AuthorizationServiceApi - object-oriented interface
 * @export
 * @class AuthorizationServiceApi
 * @extends {BaseAPI}
 */
var AuthorizationServiceApi = /** @class */ (function (_super) {
    __extends(AuthorizationServiceApi, _super);
    function AuthorizationServiceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This API is intended to be used in order to resolve the accessible menu items. It receives either a list of categories or empty list to fetch all categories and list of actions per category or none to check for any available permission. The response of the API is a list of accessible categories. If the requesting user is a reseller user accessing a customer organization, the targetOrgToken header should include the exchanged token for this customer. If the requesting user is a customer - the request body should include all reseller tokens.
     * @summary Get all categories the user is authorized to access with at least one permission
     * @param {AuthorizationServiceApiGetAccessibleCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationServiceApi
     */
    AuthorizationServiceApi.prototype.getAccessibleCategories = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AuthorizationServiceApiFp)(this.configuration).getAccessibleCategories(requestParameters.accessToken, requestParameters.targetOrgToken, requestParameters.accessibleCategoriesRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all categories the user is authorized to access with at least one permission, and the allowed actions for each category
     * @summary Get the categories and actions that the user is authorized to access
     * @param {AuthorizationServiceApiGetAccessibleCategoriesAndActionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationServiceApi
     */
    AuthorizationServiceApi.prototype.getAccessibleCategoriesAndActions = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AuthorizationServiceApiFp)(this.configuration).getAccessibleCategoriesAndActions(requestParameters.accessToken, requestParameters.accessibleCategoriesRequest, requestParameters.targetOrgToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get data entities accessible to the user
     * @param {AuthorizationServiceApiGetAccessibleDataEntitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationServiceApi
     */
    AuthorizationServiceApi.prototype.getAccessibleDataEntities = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AuthorizationServiceApiFp)(this.configuration).getAccessibleDataEntities(requestParameters.accessToken, requestParameters.targetOrgToken, requestParameters.includeLinkedAccounts, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all the entities the user is authorized to do the given actions on, for the given category. The access token header should include the login token for the requesting user. To get the entities of the current organization only - send just the AccessToken header. To get the entities of a customer only, send the AccessToken and the TargetOrgToken headers, where the TargetOrgToken has the customer\'s exchange token. To get the entities of the current organization AND its resellers, send the AccessToken header, and in the body include all the resellers tokens.
     * @summary Get all entities the user is authorized to do the given actions on, for the given category
     * @param {AuthorizationServiceApiGetAuthorizedEntitiesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationServiceApi
     */
    AuthorizationServiceApi.prototype.getAuthorizedEntities = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AuthorizationServiceApiFp)(this.configuration).getAuthorizedEntities(requestParameters.accessToken, requestParameters.getAuthorizedEntitiesRequest, requestParameters.targetOrgToken, requestParameters.paginationToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Check if the user is authorized to do all the given actions for all the given entities. If yes, returns a token that expresses that what was requested is actually allowed. The access token header should include the login token for the requesting user. In case the owner organization of the required resources is not the user\'s organization, the TargetTokenOrgHeader should include the exchange token for this organization.
     * @summary check all permissions
     * @param {AuthorizationServiceApiIsAuthorizedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationServiceApi
     */
    AuthorizationServiceApi.prototype.isAuthorized = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AuthorizationServiceApiFp)(this.configuration).isAuthorized(requestParameters.accessToken, requestParameters.targetOrgToken, requestParameters.isAuthorizedRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * For every category, check that the user is allowed to do all the required actions on at least one entity with at least one of the tokens. If the requesting user is a reseller user accessing a customer organization, the targetOrgToken header should include the exchanged token for this customer. If the requesting user is a customer - the request body should include all reseller tokens.
     * @summary check minimal permissions for all categories and actions
     * @param {AuthorizationServiceApiIsAuthorizedForCategoriesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AuthorizationServiceApi
     */
    AuthorizationServiceApi.prototype.isAuthorizedForCategories = function (requestParameters, options) {
        var _this = this;
        return (0, exports.AuthorizationServiceApiFp)(this.configuration).isAuthorizedForCategories(requestParameters.accessToken, requestParameters.targetOrgToken, requestParameters.accessibleCategoriesRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return AuthorizationServiceApi;
}(base_1.BaseAPI));
exports.AuthorizationServiceApi = AuthorizationServiceApi;
/**
 * EntitiesSharingServiceApi - axios parameter creator
 * @export
 */
var EntitiesSharingServiceApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get the roles that this entity is shared with, and the actions that each role has on this entity. The returned roles of this request would be only roles that the user is allowed to update or roles that are assigned to this user
         * @summary Get the roles and actions that this entity is shared with
         * @param {string} accessToken
         * @param {IEntityCategory} category
         * @param {string} entityId
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharedRolesAndActionsForEntity: function (accessToken_1, category_1, entityId_1, targetOrgToken_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, category_1, entityId_1, targetOrgToken_1], args_1, true), void 0, function (accessToken, category, entityId, targetOrgToken, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('getSharedRolesAndActionsForEntity', 'accessToken', accessToken);
                    // verify required parameter 'category' is not null or undefined
                    (0, common_1.assertParamExists)('getSharedRolesAndActionsForEntity', 'category', category);
                    // verify required parameter 'entityId' is not null or undefined
                    (0, common_1.assertParamExists)('getSharedRolesAndActionsForEntity', 'entityId', entityId);
                    localVarPath = "/api/v1/entities/{category}/{entityId}/permissions"
                        .replace("{".concat("category", "}"), encodeURIComponent(String(category)))
                        .replace("{".concat("entityId", "}"), encodeURIComponent(String(entityId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Share the entity of the given category and id, with all customers. The action defines what the customers are allowed to do with this entity. The access token header should include the login token for the requesting user, which is expected to be a reseller user.
         * @summary Share / unshare an entity with all customers
         * @param {string} accessToken
         * @param {IEntityCategory} category
         * @param {string} entityId
         * @param {ShareEntityWithAllCustomersRequest} shareEntityWithAllCustomersRequest
         * @param {boolean} [share]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareEntityWithAllCustomers: function (accessToken_1, category_1, entityId_1, shareEntityWithAllCustomersRequest_1, share_1) {
            var args_1 = [];
            for (var _i = 5; _i < arguments.length; _i++) {
                args_1[_i - 5] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, category_1, entityId_1, shareEntityWithAllCustomersRequest_1, share_1], args_1, true), void 0, function (accessToken, category, entityId, shareEntityWithAllCustomersRequest, share, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('shareEntityWithAllCustomers', 'accessToken', accessToken);
                    // verify required parameter 'category' is not null or undefined
                    (0, common_1.assertParamExists)('shareEntityWithAllCustomers', 'category', category);
                    // verify required parameter 'entityId' is not null or undefined
                    (0, common_1.assertParamExists)('shareEntityWithAllCustomers', 'entityId', entityId);
                    // verify required parameter 'shareEntityWithAllCustomersRequest' is not null or undefined
                    (0, common_1.assertParamExists)('shareEntityWithAllCustomers', 'shareEntityWithAllCustomersRequest', shareEntityWithAllCustomersRequest);
                    localVarPath = "/api/v1/entities/{category}/{entityId}/share-with-all-customers"
                        .replace("{".concat("category", "}"), encodeURIComponent(String(category)))
                        .replace("{".concat("entityId", "}"), encodeURIComponent(String(entityId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (share !== undefined) {
                        localVarQueryParameter['share'] = share;
                    }
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(shareEntityWithAllCustomersRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Share the entity of the given category and id, with the default role of the user whose token is provided in the access token header. If the user doesn\'t have a default role, the result would be 200, but no change will be done, so it is safe to call this api for every new entity created by every user, even for those users that don\'t have a default role.
         * @summary Share an entity with the user\'s default role
         * @param {string} accessToken
         * @param {IEntityCategory} category
         * @param {string} entityId
         * @param {Array<string>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareEntityWithDefaultRole: function (accessToken_1, category_1, entityId_1, requestBody_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, category_1, entityId_1, requestBody_1], args_1, true), void 0, function (accessToken, category, entityId, requestBody, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('shareEntityWithDefaultRole', 'accessToken', accessToken);
                    // verify required parameter 'category' is not null or undefined
                    (0, common_1.assertParamExists)('shareEntityWithDefaultRole', 'category', category);
                    // verify required parameter 'entityId' is not null or undefined
                    (0, common_1.assertParamExists)('shareEntityWithDefaultRole', 'entityId', entityId);
                    localVarPath = "/api/v1/entities/{category}/{entityId}/share-with-default-role"
                        .replace("{".concat("category", "}"), encodeURIComponent(String(category)))
                        .replace("{".concat("entityId", "}"), encodeURIComponent(String(entityId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Share or unshare specific actions of an entity with roles. The user is allowed to share only with roles that he is allowed to update or roles that are assigned to him. The user is allowed to add or remove only actions that he has permissions to do for the given entity.
         * @summary Share / unshare entity with roles
         * @param {string} accessToken
         * @param {IEntityCategory} category
         * @param {string} entityId
         * @param {Array<UpdateRolePermissionForEntityRequest>} updateRolePermissionForEntityRequest
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareUnshareEntityWithRoles: function (accessToken_1, category_1, entityId_1, updateRolePermissionForEntityRequest_1, targetOrgToken_1) {
            var args_1 = [];
            for (var _i = 5; _i < arguments.length; _i++) {
                args_1[_i - 5] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, category_1, entityId_1, updateRolePermissionForEntityRequest_1, targetOrgToken_1], args_1, true), void 0, function (accessToken, category, entityId, updateRolePermissionForEntityRequest, targetOrgToken, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('shareUnshareEntityWithRoles', 'accessToken', accessToken);
                    // verify required parameter 'category' is not null or undefined
                    (0, common_1.assertParamExists)('shareUnshareEntityWithRoles', 'category', category);
                    // verify required parameter 'entityId' is not null or undefined
                    (0, common_1.assertParamExists)('shareUnshareEntityWithRoles', 'entityId', entityId);
                    // verify required parameter 'updateRolePermissionForEntityRequest' is not null or undefined
                    (0, common_1.assertParamExists)('shareUnshareEntityWithRoles', 'updateRolePermissionForEntityRequest', updateRolePermissionForEntityRequest);
                    localVarPath = "/api/v1/entities/{category}/{entityId}/permissions"
                        .replace("{".concat("category", "}"), encodeURIComponent(String(category)))
                        .replace("{".concat("entityId", "}"), encodeURIComponent(String(entityId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateRolePermissionForEntityRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.EntitiesSharingServiceApiAxiosParamCreator = EntitiesSharingServiceApiAxiosParamCreator;
/**
 * EntitiesSharingServiceApi - functional programming interface
 * @export
 */
var EntitiesSharingServiceApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.EntitiesSharingServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get the roles that this entity is shared with, and the actions that each role has on this entity. The returned roles of this request would be only roles that the user is allowed to update or roles that are assigned to this user
         * @summary Get the roles and actions that this entity is shared with
         * @param {string} accessToken
         * @param {IEntityCategory} category
         * @param {string} entityId
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharedRolesAndActionsForEntity: function (accessToken, category, entityId, targetOrgToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSharedRolesAndActionsForEntity(accessToken, category, entityId, targetOrgToken, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EntitiesSharingServiceApi.getSharedRolesAndActionsForEntity']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Share the entity of the given category and id, with all customers. The action defines what the customers are allowed to do with this entity. The access token header should include the login token for the requesting user, which is expected to be a reseller user.
         * @summary Share / unshare an entity with all customers
         * @param {string} accessToken
         * @param {IEntityCategory} category
         * @param {string} entityId
         * @param {ShareEntityWithAllCustomersRequest} shareEntityWithAllCustomersRequest
         * @param {boolean} [share]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareEntityWithAllCustomers: function (accessToken, category, entityId, shareEntityWithAllCustomersRequest, share, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shareEntityWithAllCustomers(accessToken, category, entityId, shareEntityWithAllCustomersRequest, share, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EntitiesSharingServiceApi.shareEntityWithAllCustomers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Share the entity of the given category and id, with the default role of the user whose token is provided in the access token header. If the user doesn\'t have a default role, the result would be 200, but no change will be done, so it is safe to call this api for every new entity created by every user, even for those users that don\'t have a default role.
         * @summary Share an entity with the user\'s default role
         * @param {string} accessToken
         * @param {IEntityCategory} category
         * @param {string} entityId
         * @param {Array<string>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareEntityWithDefaultRole: function (accessToken, category, entityId, requestBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shareEntityWithDefaultRole(accessToken, category, entityId, requestBody, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EntitiesSharingServiceApi.shareEntityWithDefaultRole']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Share or unshare specific actions of an entity with roles. The user is allowed to share only with roles that he is allowed to update or roles that are assigned to him. The user is allowed to add or remove only actions that he has permissions to do for the given entity.
         * @summary Share / unshare entity with roles
         * @param {string} accessToken
         * @param {IEntityCategory} category
         * @param {string} entityId
         * @param {Array<UpdateRolePermissionForEntityRequest>} updateRolePermissionForEntityRequest
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareUnshareEntityWithRoles: function (accessToken, category, entityId, updateRolePermissionForEntityRequest, targetOrgToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shareUnshareEntityWithRoles(accessToken, category, entityId, updateRolePermissionForEntityRequest, targetOrgToken, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['EntitiesSharingServiceApi.shareUnshareEntityWithRoles']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.EntitiesSharingServiceApiFp = EntitiesSharingServiceApiFp;
/**
 * EntitiesSharingServiceApi - factory interface
 * @export
 */
var EntitiesSharingServiceApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.EntitiesSharingServiceApiFp)(configuration);
    return {
        /**
         * Get the roles that this entity is shared with, and the actions that each role has on this entity. The returned roles of this request would be only roles that the user is allowed to update or roles that are assigned to this user
         * @summary Get the roles and actions that this entity is shared with
         * @param {EntitiesSharingServiceApiGetSharedRolesAndActionsForEntityRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSharedRolesAndActionsForEntity: function (requestParameters, options) {
            return localVarFp.getSharedRolesAndActionsForEntity(requestParameters.accessToken, requestParameters.category, requestParameters.entityId, requestParameters.targetOrgToken, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Share the entity of the given category and id, with all customers. The action defines what the customers are allowed to do with this entity. The access token header should include the login token for the requesting user, which is expected to be a reseller user.
         * @summary Share / unshare an entity with all customers
         * @param {EntitiesSharingServiceApiShareEntityWithAllCustomersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareEntityWithAllCustomers: function (requestParameters, options) {
            return localVarFp.shareEntityWithAllCustomers(requestParameters.accessToken, requestParameters.category, requestParameters.entityId, requestParameters.shareEntityWithAllCustomersRequest, requestParameters.share, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Share the entity of the given category and id, with the default role of the user whose token is provided in the access token header. If the user doesn\'t have a default role, the result would be 200, but no change will be done, so it is safe to call this api for every new entity created by every user, even for those users that don\'t have a default role.
         * @summary Share an entity with the user\'s default role
         * @param {EntitiesSharingServiceApiShareEntityWithDefaultRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareEntityWithDefaultRole: function (requestParameters, options) {
            return localVarFp.shareEntityWithDefaultRole(requestParameters.accessToken, requestParameters.category, requestParameters.entityId, requestParameters.requestBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Share or unshare specific actions of an entity with roles. The user is allowed to share only with roles that he is allowed to update or roles that are assigned to him. The user is allowed to add or remove only actions that he has permissions to do for the given entity.
         * @summary Share / unshare entity with roles
         * @param {EntitiesSharingServiceApiShareUnshareEntityWithRolesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareUnshareEntityWithRoles: function (requestParameters, options) {
            return localVarFp.shareUnshareEntityWithRoles(requestParameters.accessToken, requestParameters.category, requestParameters.entityId, requestParameters.updateRolePermissionForEntityRequest, requestParameters.targetOrgToken, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.EntitiesSharingServiceApiFactory = EntitiesSharingServiceApiFactory;
/**
 * EntitiesSharingServiceApi - object-oriented interface
 * @export
 * @class EntitiesSharingServiceApi
 * @extends {BaseAPI}
 */
var EntitiesSharingServiceApi = /** @class */ (function (_super) {
    __extends(EntitiesSharingServiceApi, _super);
    function EntitiesSharingServiceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get the roles that this entity is shared with, and the actions that each role has on this entity. The returned roles of this request would be only roles that the user is allowed to update or roles that are assigned to this user
     * @summary Get the roles and actions that this entity is shared with
     * @param {EntitiesSharingServiceApiGetSharedRolesAndActionsForEntityRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesSharingServiceApi
     */
    EntitiesSharingServiceApi.prototype.getSharedRolesAndActionsForEntity = function (requestParameters, options) {
        var _this = this;
        return (0, exports.EntitiesSharingServiceApiFp)(this.configuration).getSharedRolesAndActionsForEntity(requestParameters.accessToken, requestParameters.category, requestParameters.entityId, requestParameters.targetOrgToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Share the entity of the given category and id, with all customers. The action defines what the customers are allowed to do with this entity. The access token header should include the login token for the requesting user, which is expected to be a reseller user.
     * @summary Share / unshare an entity with all customers
     * @param {EntitiesSharingServiceApiShareEntityWithAllCustomersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesSharingServiceApi
     */
    EntitiesSharingServiceApi.prototype.shareEntityWithAllCustomers = function (requestParameters, options) {
        var _this = this;
        return (0, exports.EntitiesSharingServiceApiFp)(this.configuration).shareEntityWithAllCustomers(requestParameters.accessToken, requestParameters.category, requestParameters.entityId, requestParameters.shareEntityWithAllCustomersRequest, requestParameters.share, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Share the entity of the given category and id, with the default role of the user whose token is provided in the access token header. If the user doesn\'t have a default role, the result would be 200, but no change will be done, so it is safe to call this api for every new entity created by every user, even for those users that don\'t have a default role.
     * @summary Share an entity with the user\'s default role
     * @param {EntitiesSharingServiceApiShareEntityWithDefaultRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesSharingServiceApi
     */
    EntitiesSharingServiceApi.prototype.shareEntityWithDefaultRole = function (requestParameters, options) {
        var _this = this;
        return (0, exports.EntitiesSharingServiceApiFp)(this.configuration).shareEntityWithDefaultRole(requestParameters.accessToken, requestParameters.category, requestParameters.entityId, requestParameters.requestBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Share or unshare specific actions of an entity with roles. The user is allowed to share only with roles that he is allowed to update or roles that are assigned to him. The user is allowed to add or remove only actions that he has permissions to do for the given entity.
     * @summary Share / unshare entity with roles
     * @param {EntitiesSharingServiceApiShareUnshareEntityWithRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof EntitiesSharingServiceApi
     */
    EntitiesSharingServiceApi.prototype.shareUnshareEntityWithRoles = function (requestParameters, options) {
        var _this = this;
        return (0, exports.EntitiesSharingServiceApiFp)(this.configuration).shareUnshareEntityWithRoles(requestParameters.accessToken, requestParameters.category, requestParameters.entityId, requestParameters.updateRolePermissionForEntityRequest, requestParameters.targetOrgToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return EntitiesSharingServiceApi;
}(base_1.BaseAPI));
exports.EntitiesSharingServiceApi = EntitiesSharingServiceApi;
/**
 * MigrationServiceApi - axios parameter creator
 * @export
 */
var MigrationServiceApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Add or update a batch of roles as part of migration, and assign them to the relevant users. The requesting user should have permissions to create and update roles
         * @summary Add roles as part of migration and assign them to users
         * @param {string} accessToken
         * @param {Array<RoleToMigrate>} roleToMigrate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRolesForMigration: function (accessToken_1, roleToMigrate_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, roleToMigrate_1], args_1, true), void 0, function (accessToken, roleToMigrate, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('addRolesForMigration', 'accessToken', accessToken);
                    // verify required parameter 'roleToMigrate' is not null or undefined
                    (0, common_1.assertParamExists)('addRolesForMigration', 'roleToMigrate', roleToMigrate);
                    localVarPath = "/api/v1/migration/add-and-assign-roles";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(roleToMigrate, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Add a batch of users as part of migration. The requesting user should have permissions to add users. Reset-password emails will not be sent as part of this operation.
         * @summary Add a batch of users as part of migration
         * @param {string} accessToken
         * @param {Array<User>} user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUsersForMigration: function (accessToken_1, user_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, user_1], args_1, true), void 0, function (accessToken, user, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('addUsersForMigration', 'accessToken', accessToken);
                    // verify required parameter 'user' is not null or undefined
                    (0, common_1.assertParamExists)('addUsersForMigration', 'user', user);
                    localVarPath = "/api/v1/migration/add-users";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(user, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get a token to be used for migration operations.
         * @summary Get migration admin token
         * @param {string} [clientSecret] The secret to use to connect to the requested client. The secret should be encrypted by the predefined encryption key.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMigrationToken: function (clientSecret_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([clientSecret_1], args_1, true), void 0, function (clientSecret, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/migration/token";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (clientSecret != null) {
                        localVarHeaderParameter['ClientSecret'] = String(clientSecret);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get impersonation token for the given user of the given organization. Calling this operation requires permissions to list and impersonate users. Impersonation that is based on username is supposed to happen only as part of the migration process.
         * @summary Migration - impersonate as user of organization
         * @param {string} accessToken
         * @param {string} organizationId
         * @param {string} username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impersonateForMigration: function (accessToken_1, organizationId_1, username_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, organizationId_1, username_1], args_1, true), void 0, function (accessToken, organizationId, username, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('impersonateForMigration', 'accessToken', accessToken);
                    // verify required parameter 'organizationId' is not null or undefined
                    (0, common_1.assertParamExists)('impersonateForMigration', 'organizationId', organizationId);
                    // verify required parameter 'username' is not null or undefined
                    (0, common_1.assertParamExists)('impersonateForMigration', 'username', username);
                    localVarPath = "/api/v1/migration/impersonation";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (organizationId !== undefined) {
                        localVarQueryParameter['organizationId'] = organizationId;
                    }
                    if (username !== undefined) {
                        localVarQueryParameter['username'] = username;
                    }
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Onboard a new organization with a specific organization id. Such operation is supposed to happen only as part of migration process. This onboarding process will not send a reset credentials email to the super admin
         * @summary Migration - onboard an organization
         * @param {string} accessToken
         * @param {string} organizationId
         * @param {OnboardingRequest} onboardingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onboardMigratedOrganization: function (accessToken_1, organizationId_1, onboardingRequest_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, organizationId_1, onboardingRequest_1], args_1, true), void 0, function (accessToken, organizationId, onboardingRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('onboardMigratedOrganization', 'accessToken', accessToken);
                    // verify required parameter 'organizationId' is not null or undefined
                    (0, common_1.assertParamExists)('onboardMigratedOrganization', 'organizationId', organizationId);
                    // verify required parameter 'onboardingRequest' is not null or undefined
                    (0, common_1.assertParamExists)('onboardMigratedOrganization', 'onboardingRequest', onboardingRequest);
                    localVarPath = "/api/v1/migration/onboarding";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (organizationId !== undefined) {
                        localVarQueryParameter['organizationId'] = organizationId;
                    }
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(onboardingRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Reset the credentials of the requesting user. This operation is supposed to happen only as part of the migration process. The requestnig user should have UPDATE permissions on ORGANIZATION_MANAGEMENT category.
         * @summary Migration - reset credentials for requesting user
         * @param {string} accessToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetMyCredentials: function (accessToken_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1], args_1, true), void 0, function (accessToken, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('resetMyCredentials', 'accessToken', accessToken);
                    localVarPath = "/api/v1/migration/reset-my-credentials";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.MigrationServiceApiAxiosParamCreator = MigrationServiceApiAxiosParamCreator;
/**
 * MigrationServiceApi - functional programming interface
 * @export
 */
var MigrationServiceApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.MigrationServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         * Add or update a batch of roles as part of migration, and assign them to the relevant users. The requesting user should have permissions to create and update roles
         * @summary Add roles as part of migration and assign them to users
         * @param {string} accessToken
         * @param {Array<RoleToMigrate>} roleToMigrate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRolesForMigration: function (accessToken, roleToMigrate, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addRolesForMigration(accessToken, roleToMigrate, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MigrationServiceApi.addRolesForMigration']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Add a batch of users as part of migration. The requesting user should have permissions to add users. Reset-password emails will not be sent as part of this operation.
         * @summary Add a batch of users as part of migration
         * @param {string} accessToken
         * @param {Array<User>} user
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUsersForMigration: function (accessToken, user, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.addUsersForMigration(accessToken, user, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MigrationServiceApi.addUsersForMigration']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get a token to be used for migration operations.
         * @summary Get migration admin token
         * @param {string} [clientSecret] The secret to use to connect to the requested client. The secret should be encrypted by the predefined encryption key.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMigrationToken: function (clientSecret, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMigrationToken(clientSecret, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MigrationServiceApi.getMigrationToken']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get impersonation token for the given user of the given organization. Calling this operation requires permissions to list and impersonate users. Impersonation that is based on username is supposed to happen only as part of the migration process.
         * @summary Migration - impersonate as user of organization
         * @param {string} accessToken
         * @param {string} organizationId
         * @param {string} username
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impersonateForMigration: function (accessToken, organizationId, username, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.impersonateForMigration(accessToken, organizationId, username, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MigrationServiceApi.impersonateForMigration']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Onboard a new organization with a specific organization id. Such operation is supposed to happen only as part of migration process. This onboarding process will not send a reset credentials email to the super admin
         * @summary Migration - onboard an organization
         * @param {string} accessToken
         * @param {string} organizationId
         * @param {OnboardingRequest} onboardingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onboardMigratedOrganization: function (accessToken, organizationId, onboardingRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.onboardMigratedOrganization(accessToken, organizationId, onboardingRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MigrationServiceApi.onboardMigratedOrganization']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Reset the credentials of the requesting user. This operation is supposed to happen only as part of the migration process. The requestnig user should have UPDATE permissions on ORGANIZATION_MANAGEMENT category.
         * @summary Migration - reset credentials for requesting user
         * @param {string} accessToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetMyCredentials: function (accessToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.resetMyCredentials(accessToken, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['MigrationServiceApi.resetMyCredentials']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.MigrationServiceApiFp = MigrationServiceApiFp;
/**
 * MigrationServiceApi - factory interface
 * @export
 */
var MigrationServiceApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.MigrationServiceApiFp)(configuration);
    return {
        /**
         * Add or update a batch of roles as part of migration, and assign them to the relevant users. The requesting user should have permissions to create and update roles
         * @summary Add roles as part of migration and assign them to users
         * @param {MigrationServiceApiAddRolesForMigrationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addRolesForMigration: function (requestParameters, options) {
            return localVarFp.addRolesForMigration(requestParameters.accessToken, requestParameters.roleToMigrate, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Add a batch of users as part of migration. The requesting user should have permissions to add users. Reset-password emails will not be sent as part of this operation.
         * @summary Add a batch of users as part of migration
         * @param {MigrationServiceApiAddUsersForMigrationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addUsersForMigration: function (requestParameters, options) {
            return localVarFp.addUsersForMigration(requestParameters.accessToken, requestParameters.user, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get a token to be used for migration operations.
         * @summary Get migration admin token
         * @param {MigrationServiceApiGetMigrationTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMigrationToken: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.getMigrationToken(requestParameters.clientSecret, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get impersonation token for the given user of the given organization. Calling this operation requires permissions to list and impersonate users. Impersonation that is based on username is supposed to happen only as part of the migration process.
         * @summary Migration - impersonate as user of organization
         * @param {MigrationServiceApiImpersonateForMigrationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impersonateForMigration: function (requestParameters, options) {
            return localVarFp.impersonateForMigration(requestParameters.accessToken, requestParameters.organizationId, requestParameters.username, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Onboard a new organization with a specific organization id. Such operation is supposed to happen only as part of migration process. This onboarding process will not send a reset credentials email to the super admin
         * @summary Migration - onboard an organization
         * @param {MigrationServiceApiOnboardMigratedOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onboardMigratedOrganization: function (requestParameters, options) {
            return localVarFp.onboardMigratedOrganization(requestParameters.accessToken, requestParameters.organizationId, requestParameters.onboardingRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Reset the credentials of the requesting user. This operation is supposed to happen only as part of the migration process. The requestnig user should have UPDATE permissions on ORGANIZATION_MANAGEMENT category.
         * @summary Migration - reset credentials for requesting user
         * @param {MigrationServiceApiResetMyCredentialsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetMyCredentials: function (requestParameters, options) {
            return localVarFp.resetMyCredentials(requestParameters.accessToken, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.MigrationServiceApiFactory = MigrationServiceApiFactory;
/**
 * MigrationServiceApi - object-oriented interface
 * @export
 * @class MigrationServiceApi
 * @extends {BaseAPI}
 */
var MigrationServiceApi = /** @class */ (function (_super) {
    __extends(MigrationServiceApi, _super);
    function MigrationServiceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Add or update a batch of roles as part of migration, and assign them to the relevant users. The requesting user should have permissions to create and update roles
     * @summary Add roles as part of migration and assign them to users
     * @param {MigrationServiceApiAddRolesForMigrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationServiceApi
     */
    MigrationServiceApi.prototype.addRolesForMigration = function (requestParameters, options) {
        var _this = this;
        return (0, exports.MigrationServiceApiFp)(this.configuration).addRolesForMigration(requestParameters.accessToken, requestParameters.roleToMigrate, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Add a batch of users as part of migration. The requesting user should have permissions to add users. Reset-password emails will not be sent as part of this operation.
     * @summary Add a batch of users as part of migration
     * @param {MigrationServiceApiAddUsersForMigrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationServiceApi
     */
    MigrationServiceApi.prototype.addUsersForMigration = function (requestParameters, options) {
        var _this = this;
        return (0, exports.MigrationServiceApiFp)(this.configuration).addUsersForMigration(requestParameters.accessToken, requestParameters.user, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get a token to be used for migration operations.
     * @summary Get migration admin token
     * @param {MigrationServiceApiGetMigrationTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationServiceApi
     */
    MigrationServiceApi.prototype.getMigrationToken = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.MigrationServiceApiFp)(this.configuration).getMigrationToken(requestParameters.clientSecret, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get impersonation token for the given user of the given organization. Calling this operation requires permissions to list and impersonate users. Impersonation that is based on username is supposed to happen only as part of the migration process.
     * @summary Migration - impersonate as user of organization
     * @param {MigrationServiceApiImpersonateForMigrationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationServiceApi
     */
    MigrationServiceApi.prototype.impersonateForMigration = function (requestParameters, options) {
        var _this = this;
        return (0, exports.MigrationServiceApiFp)(this.configuration).impersonateForMigration(requestParameters.accessToken, requestParameters.organizationId, requestParameters.username, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Onboard a new organization with a specific organization id. Such operation is supposed to happen only as part of migration process. This onboarding process will not send a reset credentials email to the super admin
     * @summary Migration - onboard an organization
     * @param {MigrationServiceApiOnboardMigratedOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationServiceApi
     */
    MigrationServiceApi.prototype.onboardMigratedOrganization = function (requestParameters, options) {
        var _this = this;
        return (0, exports.MigrationServiceApiFp)(this.configuration).onboardMigratedOrganization(requestParameters.accessToken, requestParameters.organizationId, requestParameters.onboardingRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Reset the credentials of the requesting user. This operation is supposed to happen only as part of the migration process. The requestnig user should have UPDATE permissions on ORGANIZATION_MANAGEMENT category.
     * @summary Migration - reset credentials for requesting user
     * @param {MigrationServiceApiResetMyCredentialsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MigrationServiceApi
     */
    MigrationServiceApi.prototype.resetMyCredentials = function (requestParameters, options) {
        var _this = this;
        return (0, exports.MigrationServiceApiFp)(this.configuration).resetMyCredentials(requestParameters.accessToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return MigrationServiceApi;
}(base_1.BaseAPI));
exports.MigrationServiceApi = MigrationServiceApi;
/**
 * OfflineTasksServiceApi - axios parameter creator
 * @export
 */
var OfflineTasksServiceApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get a list of the users that can be set as executors for an offline task by the requesting user. These are users for which the requesting user has a permission to \'run as\'. The accessToken header should have the login token of the requesting user. If the requesting user is a reseller user defining a task for the customer - include also the exchanged token for this customer in the targetOrgToken header. In this case the returned users would be customer users.
         * @summary Get available executors
         * @param {string} accessToken
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableExecutors: function (accessToken_1, targetOrgToken_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, targetOrgToken_1], args_1, true), void 0, function (accessToken, targetOrgToken, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('getAvailableExecutors', 'accessToken', accessToken);
                    localVarPath = "/api/v1/offline-tasks/available-executors";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get the user who is the executor of an offline task. The requesting user should have permissions to view the offline task. The accessToken header should include the login token, and the task is expected to be available in this realm. If the requesting user is a reseller managing a customer task - include also the exchanged token for this customer in the targetOrgToken header. In this case the task is expected to be found in the customer realm.
         * @summary Get the executor of an offline task
         * @param {string} accessToken
         * @param {IEntityCategory} category
         * @param {string} taskId
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfflineTaskExecutor: function (accessToken_1, category_1, taskId_1, targetOrgToken_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, category_1, taskId_1, targetOrgToken_1], args_1, true), void 0, function (accessToken, category, taskId, targetOrgToken, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('getOfflineTaskExecutor', 'accessToken', accessToken);
                    // verify required parameter 'category' is not null or undefined
                    (0, common_1.assertParamExists)('getOfflineTaskExecutor', 'category', category);
                    // verify required parameter 'taskId' is not null or undefined
                    (0, common_1.assertParamExists)('getOfflineTaskExecutor', 'taskId', taskId);
                    localVarPath = "/api/v1/offline-tasks/{category}/{taskId}/executor"
                        .replace("{".concat("category", "}"), encodeURIComponent(String(category)))
                        .replace("{".concat("taskId", "}"), encodeURIComponent(String(taskId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Notify rbac service that a scheduled task was deleted. The requesting user should have permissions to update the offline task. The accessToken header should include the login token, and the task is expected to be available in this realm. If the requesting user is a reseller managing a customer task - include also the exchanged token for this customer in the targetOrgToken header. In this case the task is expected to be found in the customer realm.
         * @summary Notify about an offline task deletion
         * @param {string} accessToken
         * @param {IEntityCategory} category
         * @param {string} taskId
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyTaskDeleted: function (accessToken_1, category_1, taskId_1, targetOrgToken_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, category_1, taskId_1, targetOrgToken_1], args_1, true), void 0, function (accessToken, category, taskId, targetOrgToken, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('notifyTaskDeleted', 'accessToken', accessToken);
                    // verify required parameter 'category' is not null or undefined
                    (0, common_1.assertParamExists)('notifyTaskDeleted', 'category', category);
                    // verify required parameter 'taskId' is not null or undefined
                    (0, common_1.assertParamExists)('notifyTaskDeleted', 'taskId', taskId);
                    localVarPath = "/api/v1/offline-tasks/{category}/{taskId}/notify-deletion"
                        .replace("{".concat("category", "}"), encodeURIComponent(String(category)))
                        .replace("{".concat("taskId", "}"), encodeURIComponent(String(taskId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Set a user as the executor of an offline task. If a userId field is omitted, server will set the requesting user as the executor of the offline task. If a userId is provided, server will set it as the executor of the task, if the current user has permissions to \'runAs\' the given user. The requesting user should have permissions to update the offline task. The accessToken header should include the login token, and the task is expected to be available in this realm. If the requesting user is a reseller managing a customer task - include also the exchanged token for this customer in the targetOrgToken header. In this case the task is expected to be found in the customer realm, and the user may either be the requesting user (in this case the userId field may be omitted), or any user from the customer realm that the requesting user is allowed to \'run as\'.
         * @summary Set a user as the executor of an offline task
         * @param {string} accessToken
         * @param {IEntityCategory} category
         * @param {string} taskId
         * @param {string} [targetOrgToken]
         * @param {string} [userId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOfflineTaskExecutor: function (accessToken_1, category_1, taskId_1, targetOrgToken_1, userId_1) {
            var args_1 = [];
            for (var _i = 5; _i < arguments.length; _i++) {
                args_1[_i - 5] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, category_1, taskId_1, targetOrgToken_1, userId_1], args_1, true), void 0, function (accessToken, category, taskId, targetOrgToken, userId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('setOfflineTaskExecutor', 'accessToken', accessToken);
                    // verify required parameter 'category' is not null or undefined
                    (0, common_1.assertParamExists)('setOfflineTaskExecutor', 'category', category);
                    // verify required parameter 'taskId' is not null or undefined
                    (0, common_1.assertParamExists)('setOfflineTaskExecutor', 'taskId', taskId);
                    localVarPath = "/api/v1/offline-tasks/{category}/{taskId}/executor"
                        .replace("{".concat("category", "}"), encodeURIComponent(String(category)))
                        .replace("{".concat("taskId", "}"), encodeURIComponent(String(taskId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (userId !== undefined) {
                        localVarQueryParameter['userId'] = userId;
                    }
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.OfflineTasksServiceApiAxiosParamCreator = OfflineTasksServiceApiAxiosParamCreator;
/**
 * OfflineTasksServiceApi - functional programming interface
 * @export
 */
var OfflineTasksServiceApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.OfflineTasksServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get a list of the users that can be set as executors for an offline task by the requesting user. These are users for which the requesting user has a permission to \'run as\'. The accessToken header should have the login token of the requesting user. If the requesting user is a reseller user defining a task for the customer - include also the exchanged token for this customer in the targetOrgToken header. In this case the returned users would be customer users.
         * @summary Get available executors
         * @param {string} accessToken
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableExecutors: function (accessToken, targetOrgToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAvailableExecutors(accessToken, targetOrgToken, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OfflineTasksServiceApi.getAvailableExecutors']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get the user who is the executor of an offline task. The requesting user should have permissions to view the offline task. The accessToken header should include the login token, and the task is expected to be available in this realm. If the requesting user is a reseller managing a customer task - include also the exchanged token for this customer in the targetOrgToken header. In this case the task is expected to be found in the customer realm.
         * @summary Get the executor of an offline task
         * @param {string} accessToken
         * @param {IEntityCategory} category
         * @param {string} taskId
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfflineTaskExecutor: function (accessToken, category, taskId, targetOrgToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getOfflineTaskExecutor(accessToken, category, taskId, targetOrgToken, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OfflineTasksServiceApi.getOfflineTaskExecutor']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Notify rbac service that a scheduled task was deleted. The requesting user should have permissions to update the offline task. The accessToken header should include the login token, and the task is expected to be available in this realm. If the requesting user is a reseller managing a customer task - include also the exchanged token for this customer in the targetOrgToken header. In this case the task is expected to be found in the customer realm.
         * @summary Notify about an offline task deletion
         * @param {string} accessToken
         * @param {IEntityCategory} category
         * @param {string} taskId
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyTaskDeleted: function (accessToken, category, taskId, targetOrgToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.notifyTaskDeleted(accessToken, category, taskId, targetOrgToken, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OfflineTasksServiceApi.notifyTaskDeleted']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Set a user as the executor of an offline task. If a userId field is omitted, server will set the requesting user as the executor of the offline task. If a userId is provided, server will set it as the executor of the task, if the current user has permissions to \'runAs\' the given user. The requesting user should have permissions to update the offline task. The accessToken header should include the login token, and the task is expected to be available in this realm. If the requesting user is a reseller managing a customer task - include also the exchanged token for this customer in the targetOrgToken header. In this case the task is expected to be found in the customer realm, and the user may either be the requesting user (in this case the userId field may be omitted), or any user from the customer realm that the requesting user is allowed to \'run as\'.
         * @summary Set a user as the executor of an offline task
         * @param {string} accessToken
         * @param {IEntityCategory} category
         * @param {string} taskId
         * @param {string} [targetOrgToken]
         * @param {string} [userId]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOfflineTaskExecutor: function (accessToken, category, taskId, targetOrgToken, userId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.setOfflineTaskExecutor(accessToken, category, taskId, targetOrgToken, userId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OfflineTasksServiceApi.setOfflineTaskExecutor']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.OfflineTasksServiceApiFp = OfflineTasksServiceApiFp;
/**
 * OfflineTasksServiceApi - factory interface
 * @export
 */
var OfflineTasksServiceApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.OfflineTasksServiceApiFp)(configuration);
    return {
        /**
         * Get a list of the users that can be set as executors for an offline task by the requesting user. These are users for which the requesting user has a permission to \'run as\'. The accessToken header should have the login token of the requesting user. If the requesting user is a reseller user defining a task for the customer - include also the exchanged token for this customer in the targetOrgToken header. In this case the returned users would be customer users.
         * @summary Get available executors
         * @param {OfflineTasksServiceApiGetAvailableExecutorsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableExecutors: function (requestParameters, options) {
            return localVarFp.getAvailableExecutors(requestParameters.accessToken, requestParameters.targetOrgToken, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the user who is the executor of an offline task. The requesting user should have permissions to view the offline task. The accessToken header should include the login token, and the task is expected to be available in this realm. If the requesting user is a reseller managing a customer task - include also the exchanged token for this customer in the targetOrgToken header. In this case the task is expected to be found in the customer realm.
         * @summary Get the executor of an offline task
         * @param {OfflineTasksServiceApiGetOfflineTaskExecutorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfflineTaskExecutor: function (requestParameters, options) {
            return localVarFp.getOfflineTaskExecutor(requestParameters.accessToken, requestParameters.category, requestParameters.taskId, requestParameters.targetOrgToken, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Notify rbac service that a scheduled task was deleted. The requesting user should have permissions to update the offline task. The accessToken header should include the login token, and the task is expected to be available in this realm. If the requesting user is a reseller managing a customer task - include also the exchanged token for this customer in the targetOrgToken header. In this case the task is expected to be found in the customer realm.
         * @summary Notify about an offline task deletion
         * @param {OfflineTasksServiceApiNotifyTaskDeletedRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notifyTaskDeleted: function (requestParameters, options) {
            return localVarFp.notifyTaskDeleted(requestParameters.accessToken, requestParameters.category, requestParameters.taskId, requestParameters.targetOrgToken, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Set a user as the executor of an offline task. If a userId field is omitted, server will set the requesting user as the executor of the offline task. If a userId is provided, server will set it as the executor of the task, if the current user has permissions to \'runAs\' the given user. The requesting user should have permissions to update the offline task. The accessToken header should include the login token, and the task is expected to be available in this realm. If the requesting user is a reseller managing a customer task - include also the exchanged token for this customer in the targetOrgToken header. In this case the task is expected to be found in the customer realm, and the user may either be the requesting user (in this case the userId field may be omitted), or any user from the customer realm that the requesting user is allowed to \'run as\'.
         * @summary Set a user as the executor of an offline task
         * @param {OfflineTasksServiceApiSetOfflineTaskExecutorRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setOfflineTaskExecutor: function (requestParameters, options) {
            return localVarFp.setOfflineTaskExecutor(requestParameters.accessToken, requestParameters.category, requestParameters.taskId, requestParameters.targetOrgToken, requestParameters.userId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.OfflineTasksServiceApiFactory = OfflineTasksServiceApiFactory;
/**
 * OfflineTasksServiceApi - object-oriented interface
 * @export
 * @class OfflineTasksServiceApi
 * @extends {BaseAPI}
 */
var OfflineTasksServiceApi = /** @class */ (function (_super) {
    __extends(OfflineTasksServiceApi, _super);
    function OfflineTasksServiceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get a list of the users that can be set as executors for an offline task by the requesting user. These are users for which the requesting user has a permission to \'run as\'. The accessToken header should have the login token of the requesting user. If the requesting user is a reseller user defining a task for the customer - include also the exchanged token for this customer in the targetOrgToken header. In this case the returned users would be customer users.
     * @summary Get available executors
     * @param {OfflineTasksServiceApiGetAvailableExecutorsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfflineTasksServiceApi
     */
    OfflineTasksServiceApi.prototype.getAvailableExecutors = function (requestParameters, options) {
        var _this = this;
        return (0, exports.OfflineTasksServiceApiFp)(this.configuration).getAvailableExecutors(requestParameters.accessToken, requestParameters.targetOrgToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the user who is the executor of an offline task. The requesting user should have permissions to view the offline task. The accessToken header should include the login token, and the task is expected to be available in this realm. If the requesting user is a reseller managing a customer task - include also the exchanged token for this customer in the targetOrgToken header. In this case the task is expected to be found in the customer realm.
     * @summary Get the executor of an offline task
     * @param {OfflineTasksServiceApiGetOfflineTaskExecutorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfflineTasksServiceApi
     */
    OfflineTasksServiceApi.prototype.getOfflineTaskExecutor = function (requestParameters, options) {
        var _this = this;
        return (0, exports.OfflineTasksServiceApiFp)(this.configuration).getOfflineTaskExecutor(requestParameters.accessToken, requestParameters.category, requestParameters.taskId, requestParameters.targetOrgToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Notify rbac service that a scheduled task was deleted. The requesting user should have permissions to update the offline task. The accessToken header should include the login token, and the task is expected to be available in this realm. If the requesting user is a reseller managing a customer task - include also the exchanged token for this customer in the targetOrgToken header. In this case the task is expected to be found in the customer realm.
     * @summary Notify about an offline task deletion
     * @param {OfflineTasksServiceApiNotifyTaskDeletedRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfflineTasksServiceApi
     */
    OfflineTasksServiceApi.prototype.notifyTaskDeleted = function (requestParameters, options) {
        var _this = this;
        return (0, exports.OfflineTasksServiceApiFp)(this.configuration).notifyTaskDeleted(requestParameters.accessToken, requestParameters.category, requestParameters.taskId, requestParameters.targetOrgToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Set a user as the executor of an offline task. If a userId field is omitted, server will set the requesting user as the executor of the offline task. If a userId is provided, server will set it as the executor of the task, if the current user has permissions to \'runAs\' the given user. The requesting user should have permissions to update the offline task. The accessToken header should include the login token, and the task is expected to be available in this realm. If the requesting user is a reseller managing a customer task - include also the exchanged token for this customer in the targetOrgToken header. In this case the task is expected to be found in the customer realm, and the user may either be the requesting user (in this case the userId field may be omitted), or any user from the customer realm that the requesting user is allowed to \'run as\'.
     * @summary Set a user as the executor of an offline task
     * @param {OfflineTasksServiceApiSetOfflineTaskExecutorRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OfflineTasksServiceApi
     */
    OfflineTasksServiceApi.prototype.setOfflineTaskExecutor = function (requestParameters, options) {
        var _this = this;
        return (0, exports.OfflineTasksServiceApiFp)(this.configuration).setOfflineTaskExecutor(requestParameters.accessToken, requestParameters.category, requestParameters.taskId, requestParameters.targetOrgToken, requestParameters.userId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return OfflineTasksServiceApi;
}(base_1.BaseAPI));
exports.OfflineTasksServiceApi = OfflineTasksServiceApi;
/**
 * OnboardingServiceApi - axios parameter creator
 * @export
 */
var OnboardingServiceApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * A request to start the onboarding process
         * @summary Onboard a new organization
         * @param {OnboardingRequest} onboardingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onboardOrganization: function (onboardingRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([onboardingRequest_1], args_1, true), void 0, function (onboardingRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'onboardingRequest' is not null or undefined
                    (0, common_1.assertParamExists)('onboardOrganization', 'onboardingRequest', onboardingRequest);
                    localVarPath = "/api/v1/onboarding";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(onboardingRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * A request to retry the reset credentials process. Use this request if the onboarding completed successfully, just sending a reset-credentials email has failed.
         * @summary Retry reset credentials
         * @param {string} organizationId
         * @param {string} userEmail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryResetCredentials: function (organizationId_1, userEmail_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([organizationId_1, userEmail_1], args_1, true), void 0, function (organizationId, userEmail, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'organizationId' is not null or undefined
                    (0, common_1.assertParamExists)('retryResetCredentials', 'organizationId', organizationId);
                    // verify required parameter 'userEmail' is not null or undefined
                    (0, common_1.assertParamExists)('retryResetCredentials', 'userEmail', userEmail);
                    localVarPath = "/api/v1/onboarding/retry-reset-credentials";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (organizationId !== undefined) {
                        localVarQueryParameter['organizationId'] = organizationId;
                    }
                    if (userEmail !== undefined) {
                        localVarQueryParameter['userEmail'] = userEmail;
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.OnboardingServiceApiAxiosParamCreator = OnboardingServiceApiAxiosParamCreator;
/**
 * OnboardingServiceApi - functional programming interface
 * @export
 */
var OnboardingServiceApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.OnboardingServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         * A request to start the onboarding process
         * @summary Onboard a new organization
         * @param {OnboardingRequest} onboardingRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onboardOrganization: function (onboardingRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.onboardOrganization(onboardingRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OnboardingServiceApi.onboardOrganization']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * A request to retry the reset credentials process. Use this request if the onboarding completed successfully, just sending a reset-credentials email has failed.
         * @summary Retry reset credentials
         * @param {string} organizationId
         * @param {string} userEmail
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryResetCredentials: function (organizationId, userEmail, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.retryResetCredentials(organizationId, userEmail, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['OnboardingServiceApi.retryResetCredentials']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.OnboardingServiceApiFp = OnboardingServiceApiFp;
/**
 * OnboardingServiceApi - factory interface
 * @export
 */
var OnboardingServiceApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.OnboardingServiceApiFp)(configuration);
    return {
        /**
         * A request to start the onboarding process
         * @summary Onboard a new organization
         * @param {OnboardingServiceApiOnboardOrganizationRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        onboardOrganization: function (requestParameters, options) {
            return localVarFp.onboardOrganization(requestParameters.onboardingRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * A request to retry the reset credentials process. Use this request if the onboarding completed successfully, just sending a reset-credentials email has failed.
         * @summary Retry reset credentials
         * @param {OnboardingServiceApiRetryResetCredentialsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        retryResetCredentials: function (requestParameters, options) {
            return localVarFp.retryResetCredentials(requestParameters.organizationId, requestParameters.userEmail, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.OnboardingServiceApiFactory = OnboardingServiceApiFactory;
/**
 * OnboardingServiceApi - object-oriented interface
 * @export
 * @class OnboardingServiceApi
 * @extends {BaseAPI}
 */
var OnboardingServiceApi = /** @class */ (function (_super) {
    __extends(OnboardingServiceApi, _super);
    function OnboardingServiceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * A request to start the onboarding process
     * @summary Onboard a new organization
     * @param {OnboardingServiceApiOnboardOrganizationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingServiceApi
     */
    OnboardingServiceApi.prototype.onboardOrganization = function (requestParameters, options) {
        var _this = this;
        return (0, exports.OnboardingServiceApiFp)(this.configuration).onboardOrganization(requestParameters.onboardingRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * A request to retry the reset credentials process. Use this request if the onboarding completed successfully, just sending a reset-credentials email has failed.
     * @summary Retry reset credentials
     * @param {OnboardingServiceApiRetryResetCredentialsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OnboardingServiceApi
     */
    OnboardingServiceApi.prototype.retryResetCredentials = function (requestParameters, options) {
        var _this = this;
        return (0, exports.OnboardingServiceApiFp)(this.configuration).retryResetCredentials(requestParameters.organizationId, requestParameters.userEmail, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return OnboardingServiceApi;
}(base_1.BaseAPI));
exports.OnboardingServiceApi = OnboardingServiceApi;
/**
 * ResellerCustomersServiceApi - axios parameter creator
 * @export
 */
var ResellerCustomersServiceApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * A request to register an existing organization as a customer of the requesting reseller. The accessToken header should include a token for a reseller organization user.
         * @summary Register a reseller customer
         * @param {string} accessToken
         * @param {string} customerOrganizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerExistingOrgAsResellerCustomer: function (accessToken_1, customerOrganizationId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, customerOrganizationId_1], args_1, true), void 0, function (accessToken, customerOrganizationId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('registerExistingOrgAsResellerCustomer', 'accessToken', accessToken);
                    // verify required parameter 'customerOrganizationId' is not null or undefined
                    (0, common_1.assertParamExists)('registerExistingOrgAsResellerCustomer', 'customerOrganizationId', customerOrganizationId);
                    localVarPath = "/api/v1/reseller-customers/register-org-as-customer";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (customerOrganizationId !== undefined) {
                        localVarQueryParameter['customerOrganizationId'] = customerOrganizationId;
                    }
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * A request to create a new organization and register it as a customer of the requesting reseller. The accessToken header should include a token for a reseller organization user.
         * @summary Onboard a new organization and register it as a reseller customer
         * @param {string} accessToken
         * @param {OnboardingRequest} onboardingRequest The onboarding request for the new organization. The user details are optional
         * @param {string} [resellerOrganizationId] The organization id of the reseller, to be provided if the token is a token of a system admin. Otherwise this parameter will be ignored and the reseller will be determined by the token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerNewOrgAsResellerCustomer: function (accessToken_1, onboardingRequest_1, resellerOrganizationId_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, onboardingRequest_1, resellerOrganizationId_1], args_1, true), void 0, function (accessToken, onboardingRequest, resellerOrganizationId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('registerNewOrgAsResellerCustomer', 'accessToken', accessToken);
                    // verify required parameter 'onboardingRequest' is not null or undefined
                    (0, common_1.assertParamExists)('registerNewOrgAsResellerCustomer', 'onboardingRequest', onboardingRequest);
                    localVarPath = "/api/v1/reseller-customers/register-new-org-as-customer";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (resellerOrganizationId !== undefined) {
                        localVarQueryParameter['resellerOrganizationId'] = resellerOrganizationId;
                    }
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(onboardingRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * A request to remove an existing customer from the current reseller organization. The accessToken header should include a token for a reseller organization user.
         * @summary Unregister reseller customer
         * @param {string} accessToken
         * @param {string} customerOrganizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCustomerOrg: function (accessToken_1, customerOrganizationId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, customerOrganizationId_1], args_1, true), void 0, function (accessToken, customerOrganizationId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('removeCustomerOrg', 'accessToken', accessToken);
                    // verify required parameter 'customerOrganizationId' is not null or undefined
                    (0, common_1.assertParamExists)('removeCustomerOrg', 'customerOrganizationId', customerOrganizationId);
                    localVarPath = "/api/v1/reseller-customers/unregister-customer";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (customerOrganizationId !== undefined) {
                        localVarQueryParameter['customerOrganizationId'] = customerOrganizationId;
                    }
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.ResellerCustomersServiceApiAxiosParamCreator = ResellerCustomersServiceApiAxiosParamCreator;
/**
 * ResellerCustomersServiceApi - functional programming interface
 * @export
 */
var ResellerCustomersServiceApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ResellerCustomersServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         * A request to register an existing organization as a customer of the requesting reseller. The accessToken header should include a token for a reseller organization user.
         * @summary Register a reseller customer
         * @param {string} accessToken
         * @param {string} customerOrganizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerExistingOrgAsResellerCustomer: function (accessToken, customerOrganizationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.registerExistingOrgAsResellerCustomer(accessToken, customerOrganizationId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ResellerCustomersServiceApi.registerExistingOrgAsResellerCustomer']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * A request to create a new organization and register it as a customer of the requesting reseller. The accessToken header should include a token for a reseller organization user.
         * @summary Onboard a new organization and register it as a reseller customer
         * @param {string} accessToken
         * @param {OnboardingRequest} onboardingRequest The onboarding request for the new organization. The user details are optional
         * @param {string} [resellerOrganizationId] The organization id of the reseller, to be provided if the token is a token of a system admin. Otherwise this parameter will be ignored and the reseller will be determined by the token.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerNewOrgAsResellerCustomer: function (accessToken, onboardingRequest, resellerOrganizationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.registerNewOrgAsResellerCustomer(accessToken, onboardingRequest, resellerOrganizationId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ResellerCustomersServiceApi.registerNewOrgAsResellerCustomer']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * A request to remove an existing customer from the current reseller organization. The accessToken header should include a token for a reseller organization user.
         * @summary Unregister reseller customer
         * @param {string} accessToken
         * @param {string} customerOrganizationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCustomerOrg: function (accessToken, customerOrganizationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.removeCustomerOrg(accessToken, customerOrganizationId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ResellerCustomersServiceApi.removeCustomerOrg']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.ResellerCustomersServiceApiFp = ResellerCustomersServiceApiFp;
/**
 * ResellerCustomersServiceApi - factory interface
 * @export
 */
var ResellerCustomersServiceApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ResellerCustomersServiceApiFp)(configuration);
    return {
        /**
         * A request to register an existing organization as a customer of the requesting reseller. The accessToken header should include a token for a reseller organization user.
         * @summary Register a reseller customer
         * @param {ResellerCustomersServiceApiRegisterExistingOrgAsResellerCustomerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerExistingOrgAsResellerCustomer: function (requestParameters, options) {
            return localVarFp.registerExistingOrgAsResellerCustomer(requestParameters.accessToken, requestParameters.customerOrganizationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * A request to create a new organization and register it as a customer of the requesting reseller. The accessToken header should include a token for a reseller organization user.
         * @summary Onboard a new organization and register it as a reseller customer
         * @param {ResellerCustomersServiceApiRegisterNewOrgAsResellerCustomerRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        registerNewOrgAsResellerCustomer: function (requestParameters, options) {
            return localVarFp.registerNewOrgAsResellerCustomer(requestParameters.accessToken, requestParameters.onboardingRequest, requestParameters.resellerOrganizationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * A request to remove an existing customer from the current reseller organization. The accessToken header should include a token for a reseller organization user.
         * @summary Unregister reseller customer
         * @param {ResellerCustomersServiceApiRemoveCustomerOrgRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        removeCustomerOrg: function (requestParameters, options) {
            return localVarFp.removeCustomerOrg(requestParameters.accessToken, requestParameters.customerOrganizationId, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ResellerCustomersServiceApiFactory = ResellerCustomersServiceApiFactory;
/**
 * ResellerCustomersServiceApi - object-oriented interface
 * @export
 * @class ResellerCustomersServiceApi
 * @extends {BaseAPI}
 */
var ResellerCustomersServiceApi = /** @class */ (function (_super) {
    __extends(ResellerCustomersServiceApi, _super);
    function ResellerCustomersServiceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * A request to register an existing organization as a customer of the requesting reseller. The accessToken header should include a token for a reseller organization user.
     * @summary Register a reseller customer
     * @param {ResellerCustomersServiceApiRegisterExistingOrgAsResellerCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellerCustomersServiceApi
     */
    ResellerCustomersServiceApi.prototype.registerExistingOrgAsResellerCustomer = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ResellerCustomersServiceApiFp)(this.configuration).registerExistingOrgAsResellerCustomer(requestParameters.accessToken, requestParameters.customerOrganizationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * A request to create a new organization and register it as a customer of the requesting reseller. The accessToken header should include a token for a reseller organization user.
     * @summary Onboard a new organization and register it as a reseller customer
     * @param {ResellerCustomersServiceApiRegisterNewOrgAsResellerCustomerRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellerCustomersServiceApi
     */
    ResellerCustomersServiceApi.prototype.registerNewOrgAsResellerCustomer = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ResellerCustomersServiceApiFp)(this.configuration).registerNewOrgAsResellerCustomer(requestParameters.accessToken, requestParameters.onboardingRequest, requestParameters.resellerOrganizationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * A request to remove an existing customer from the current reseller organization. The accessToken header should include a token for a reseller organization user.
     * @summary Unregister reseller customer
     * @param {ResellerCustomersServiceApiRemoveCustomerOrgRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ResellerCustomersServiceApi
     */
    ResellerCustomersServiceApi.prototype.removeCustomerOrg = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ResellerCustomersServiceApiFp)(this.configuration).removeCustomerOrg(requestParameters.accessToken, requestParameters.customerOrganizationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ResellerCustomersServiceApi;
}(base_1.BaseAPI));
exports.ResellerCustomersServiceApi = ResellerCustomersServiceApi;
/**
 * RolesServiceApi - axios parameter creator
 * @export
 */
var RolesServiceApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create a new role in Keycloak. The access token header should include the login token for the requesting user. If the requesting user is a reseller user creating a role for the customer - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Create a role
         * @param {string} accessToken
         * @param {string} [targetOrgToken]
         * @param {Role} [role]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRole: function (accessToken_1, targetOrgToken_1, role_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, targetOrgToken_1, role_1], args_1, true), void 0, function (accessToken, targetOrgToken, role, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('createRole', 'accessToken', accessToken);
                    localVarPath = "/api/v1/roles";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(role, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Batch delete roles. The request body should include a list of role ids to delete. The access token header should include the login token for the requesting user. If the requesting user is a reseller user deleting a customer role - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Delete roles
         * @param {string} accessToken
         * @param {string} [targetOrgToken]
         * @param {Array<string>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoles: function (accessToken_1, targetOrgToken_1, requestBody_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, targetOrgToken_1, requestBody_1], args_1, true), void 0, function (accessToken, targetOrgToken, requestBody, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('deleteRoles', 'accessToken', accessToken);
                    localVarPath = "/api/v1/roles";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * For each category that permissions can be set, get the available actions. Based on the token, the server will return only the relevant categories: system_management will return only for anodot realm, reseller_customers will return only for reseller realms.
         * @summary Get available category actions
         * @param {string} accessToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableCategoryActions: function (accessToken_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1], args_1, true), void 0, function (accessToken, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('getAvailableCategoryActions', 'accessToken', accessToken);
                    localVarPath = "/api/v1/roles/permissions/available-category-actions";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get data access of a role. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing a customer role - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Get data access of role
         * @param {string} accessToken
         * @param {string} roleId
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataAccessOfRole: function (accessToken_1, roleId_1, targetOrgToken_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, roleId_1, targetOrgToken_1], args_1, true), void 0, function (accessToken, roleId, targetOrgToken, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('getDataAccessOfRole', 'accessToken', accessToken);
                    // verify required parameter 'roleId' is not null or undefined
                    (0, common_1.assertParamExists)('getDataAccessOfRole', 'roleId', roleId);
                    localVarPath = "/api/v1/roles/{roleId}/data-access"
                        .replace("{".concat("roleId", "}"), encodeURIComponent(String(roleId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get the merged partial permission details for a set of roles for a given category and action. The request body contain the role ids. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing permissions for customer roles - include also the exchanged token for this customer in the targetOrgToken header. In this case all the roles are expected to be customer roles.
         * @summary Get partial permissions for a set of roles, a category and an action
         * @param {string} accessToken
         * @param {IEntityCategory} category
         * @param {IAction} action
         * @param {Array<string>} requestBody
         * @param {string} [targetOrgToken]
         * @param {string} [paginationToken] The token received in the previous response. if this is the first request - omit.
         * @param {number} [pageSize] Indicates how many entries to return. Must be a positive number or 0. If omitted, a default page size will be used (configurable in properties). If 0 - all entries will be returned (in this case pagination token will be ignored).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMergedPartialPermissionsOfRoles: function (accessToken_1, category_1, action_1, requestBody_1, targetOrgToken_1, paginationToken_1, pageSize_1) {
            var args_1 = [];
            for (var _i = 7; _i < arguments.length; _i++) {
                args_1[_i - 7] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, category_1, action_1, requestBody_1, targetOrgToken_1, paginationToken_1, pageSize_1], args_1, true), void 0, function (accessToken, category, action, requestBody, targetOrgToken, paginationToken, pageSize, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('getMergedPartialPermissionsOfRoles', 'accessToken', accessToken);
                    // verify required parameter 'category' is not null or undefined
                    (0, common_1.assertParamExists)('getMergedPartialPermissionsOfRoles', 'category', category);
                    // verify required parameter 'action' is not null or undefined
                    (0, common_1.assertParamExists)('getMergedPartialPermissionsOfRoles', 'action', action);
                    // verify required parameter 'requestBody' is not null or undefined
                    (0, common_1.assertParamExists)('getMergedPartialPermissionsOfRoles', 'requestBody', requestBody);
                    localVarPath = "/api/v1/roles/get-merged-permissions/{category}/{action}"
                        .replace("{".concat("category", "}"), encodeURIComponent(String(category)))
                        .replace("{".concat("action", "}"), encodeURIComponent(String(action)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationToken !== undefined) {
                        localVarQueryParameter['paginationToken'] = paginationToken;
                    }
                    if (pageSize !== undefined) {
                        localVarQueryParameter['pageSize'] = pageSize;
                    }
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get the merged permissions for a set of roles. The request body contain the role ids. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing permissions for customer roles - include also the exchanged token for this customer in the targetOrgToken header. In this case all the roles are expected to be customer roles.
         * @summary Get permissions for a set of roles
         * @param {string} accessToken
         * @param {Array<string>} requestBody
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMergedPermissionsOfRoles: function (accessToken_1, requestBody_1, targetOrgToken_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, requestBody_1, targetOrgToken_1], args_1, true), void 0, function (accessToken, requestBody, targetOrgToken, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('getMergedPermissionsOfRoles', 'accessToken', accessToken);
                    // verify required parameter 'requestBody' is not null or undefined
                    (0, common_1.assertParamExists)('getMergedPermissionsOfRoles', 'requestBody', requestBody);
                    localVarPath = "/api/v1/roles/get-merged-permissions";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get partial permission details of a role for a given category and action. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing permissions for a customer role - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Get partial permissions of role, category and action
         * @param {string} accessToken
         * @param {string} roleId
         * @param {IEntityCategory} category
         * @param {IAction} action
         * @param {string} [targetOrgToken]
         * @param {string} [paginationToken] The token received in the previous response. if this is the first request - omit.
         * @param {number} [pageSize] Indicates how many entries to return. Must be a positive number or 0. If omitted, a default page size will be used (configurable in properties). If 0 - all entries will be returned (in this case pagination token will be ignored).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartialPermissionsOfRole: function (accessToken_1, roleId_1, category_1, action_1, targetOrgToken_1, paginationToken_1, pageSize_1) {
            var args_1 = [];
            for (var _i = 7; _i < arguments.length; _i++) {
                args_1[_i - 7] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, roleId_1, category_1, action_1, targetOrgToken_1, paginationToken_1, pageSize_1], args_1, true), void 0, function (accessToken, roleId, category, action, targetOrgToken, paginationToken, pageSize, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('getPartialPermissionsOfRole', 'accessToken', accessToken);
                    // verify required parameter 'roleId' is not null or undefined
                    (0, common_1.assertParamExists)('getPartialPermissionsOfRole', 'roleId', roleId);
                    // verify required parameter 'category' is not null or undefined
                    (0, common_1.assertParamExists)('getPartialPermissionsOfRole', 'category', category);
                    // verify required parameter 'action' is not null or undefined
                    (0, common_1.assertParamExists)('getPartialPermissionsOfRole', 'action', action);
                    localVarPath = "/api/v1/roles/{roleId}/permissions/{category}/{action}"
                        .replace("{".concat("roleId", "}"), encodeURIComponent(String(roleId)))
                        .replace("{".concat("category", "}"), encodeURIComponent(String(category)))
                        .replace("{".concat("action", "}"), encodeURIComponent(String(action)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationToken !== undefined) {
                        localVarQueryParameter['paginationToken'] = paginationToken;
                    }
                    if (pageSize !== undefined) {
                        localVarQueryParameter['pageSize'] = pageSize;
                    }
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all the permissions of a role. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing permissions for a customer - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Get permissions of role
         * @param {string} accessToken
         * @param {string} roleId
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissionsOfRole: function (accessToken_1, roleId_1, targetOrgToken_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, roleId_1, targetOrgToken_1], args_1, true), void 0, function (accessToken, roleId, targetOrgToken, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('getPermissionsOfRole', 'accessToken', accessToken);
                    // verify required parameter 'roleId' is not null or undefined
                    (0, common_1.assertParamExists)('getPermissionsOfRole', 'roleId', roleId);
                    localVarPath = "/api/v1/roles/{roleId}/permissions"
                        .replace("{".concat("roleId", "}"), encodeURIComponent(String(roleId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get the role details. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing a customer role - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Get role
         * @param {string} accessToken
         * @param {string} roleId
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRole: function (accessToken_1, roleId_1, targetOrgToken_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, roleId_1, targetOrgToken_1], args_1, true), void 0, function (accessToken, roleId, targetOrgToken, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('getRole', 'accessToken', accessToken);
                    // verify required parameter 'roleId' is not null or undefined
                    (0, common_1.assertParamExists)('getRole', 'roleId', roleId);
                    localVarPath = "/api/v1/roles/{roleId}"
                        .replace("{".concat("roleId", "}"), encodeURIComponent(String(roleId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get users that are assigned to the given role. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing a customer role - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Get users of role
         * @param {string} accessToken
         * @param {string} roleId
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoleUsers: function (accessToken_1, roleId_1, targetOrgToken_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, roleId_1, targetOrgToken_1], args_1, true), void 0, function (accessToken, roleId, targetOrgToken, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('getRoleUsers', 'accessToken', accessToken);
                    // verify required parameter 'roleId' is not null or undefined
                    (0, common_1.assertParamExists)('getRoleUsers', 'roleId', roleId);
                    localVarPath = "/api/v1/roles/{roleId}/users"
                        .replace("{".concat("roleId", "}"), encodeURIComponent(String(roleId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all the roles, or filter by search string. The access token header should include the login token for the requesting user. If the requesting user is a reseller user listing customer roles - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Get all roles
         * @param {string} accessToken
         * @param {string} [targetOrgToken]
         * @param {string} [search]
         * @param {number} [pageSize] Indicates how many entries to return. Must be a positive number. If omitted, a default page size will be used (configurable in properties).
         * @param {string} [paginationToken] The token received in the previous response. if this is the first request - omit.
         * @param {boolean} [excludeBuiltInRoles]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles: function (accessToken_1, targetOrgToken_1, search_1, pageSize_1, paginationToken_1, excludeBuiltInRoles_1) {
            var args_1 = [];
            for (var _i = 6; _i < arguments.length; _i++) {
                args_1[_i - 6] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, targetOrgToken_1, search_1, pageSize_1, paginationToken_1, excludeBuiltInRoles_1], args_1, true), void 0, function (accessToken, targetOrgToken, search, pageSize, paginationToken, excludeBuiltInRoles, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('getRoles', 'accessToken', accessToken);
                    localVarPath = "/api/v1/roles";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (search !== undefined) {
                        localVarQueryParameter['search'] = search;
                    }
                    if (pageSize !== undefined) {
                        localVarQueryParameter['pageSize'] = pageSize;
                    }
                    if (paginationToken !== undefined) {
                        localVarQueryParameter['paginationToken'] = paginationToken;
                    }
                    if (excludeBuiltInRoles !== undefined) {
                        localVarQueryParameter['excludeBuiltInRoles'] = excludeBuiltInRoles;
                    }
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Set permissions of a role. The access token header should include the login token for the requesting user. If the requesting user is a reseller user updating a customer role - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Set permissions of role
         * @param {string} accessToken
         * @param {string} roleId
         * @param {string} [targetOrgToken]
         * @param {Array<RoleCategoryPermissions>} [roleCategoryPermissions] The request body should include entries only for the modified categories.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPermissionsOfRole: function (accessToken_1, roleId_1, targetOrgToken_1, roleCategoryPermissions_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, roleId_1, targetOrgToken_1, roleCategoryPermissions_1], args_1, true), void 0, function (accessToken, roleId, targetOrgToken, roleCategoryPermissions, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('setPermissionsOfRole', 'accessToken', accessToken);
                    // verify required parameter 'roleId' is not null or undefined
                    (0, common_1.assertParamExists)('setPermissionsOfRole', 'roleId', roleId);
                    localVarPath = "/api/v1/roles/{roleId}/permissions"
                        .replace("{".concat("roleId", "}"), encodeURIComponent(String(roleId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(roleCategoryPermissions, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update the list of cost centers that are accessible for this role. The request should include only the changes from to the current state. The access token header should include the login token for the requesting user. If the requesting user is a reseller user updating a customer role - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Update cost centers accessible by a role
         * @param {string} accessToken
         * @param {string} roleId
         * @param {AllOrListChange} allOrListChange
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCostCentersAccessibleByRole: function (accessToken_1, roleId_1, allOrListChange_1, targetOrgToken_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, roleId_1, allOrListChange_1, targetOrgToken_1], args_1, true), void 0, function (accessToken, roleId, allOrListChange, targetOrgToken, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('updateCostCentersAccessibleByRole', 'accessToken', accessToken);
                    // verify required parameter 'roleId' is not null or undefined
                    (0, common_1.assertParamExists)('updateCostCentersAccessibleByRole', 'roleId', roleId);
                    // verify required parameter 'allOrListChange' is not null or undefined
                    (0, common_1.assertParamExists)('updateCostCentersAccessibleByRole', 'allOrListChange', allOrListChange);
                    localVarPath = "/api/v1/roles/{roleId}/data-access/cost-centers"
                        .replace("{".concat("roleId", "}"), encodeURIComponent(String(roleId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(allOrListChange, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update the list of linked accounts that are accessible for this role. The request should include only the changes from to the current state. The access token header should include the login token for the requesting user. If the requesting user is a reseller user updating a customer role - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Update linked accounts accessible by a role
         * @param {string} accessToken
         * @param {string} roleId
         * @param {UpdateLinkedAccountsAccessibleByRoleRequest} updateLinkedAccountsAccessibleByRoleRequest
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLinkedAccountsAccessibleByRole: function (accessToken_1, roleId_1, updateLinkedAccountsAccessibleByRoleRequest_1, targetOrgToken_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, roleId_1, updateLinkedAccountsAccessibleByRoleRequest_1, targetOrgToken_1], args_1, true), void 0, function (accessToken, roleId, updateLinkedAccountsAccessibleByRoleRequest, targetOrgToken, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('updateLinkedAccountsAccessibleByRole', 'accessToken', accessToken);
                    // verify required parameter 'roleId' is not null or undefined
                    (0, common_1.assertParamExists)('updateLinkedAccountsAccessibleByRole', 'roleId', roleId);
                    // verify required parameter 'updateLinkedAccountsAccessibleByRoleRequest' is not null or undefined
                    (0, common_1.assertParamExists)('updateLinkedAccountsAccessibleByRole', 'updateLinkedAccountsAccessibleByRoleRequest', updateLinkedAccountsAccessibleByRoleRequest);
                    localVarPath = "/api/v1/roles/{roleId}/data-access/linked-accounts"
                        .replace("{".concat("roleId", "}"), encodeURIComponent(String(roleId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateLinkedAccountsAccessibleByRoleRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update the list of reseller customers that are accessible for this role. The request should include only the changes from to the current state. The access token header should include the login token for the requesting user.
         * @summary Update reseller customers accessible by a role
         * @param {string} accessToken
         * @param {string} roleId
         * @param {AllOrListChange} allOrListChange
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateResellerCustomersAccessibleByRole: function (accessToken_1, roleId_1, allOrListChange_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, roleId_1, allOrListChange_1], args_1, true), void 0, function (accessToken, roleId, allOrListChange, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('updateResellerCustomersAccessibleByRole', 'accessToken', accessToken);
                    // verify required parameter 'roleId' is not null or undefined
                    (0, common_1.assertParamExists)('updateResellerCustomersAccessibleByRole', 'roleId', roleId);
                    // verify required parameter 'allOrListChange' is not null or undefined
                    (0, common_1.assertParamExists)('updateResellerCustomersAccessibleByRole', 'allOrListChange', allOrListChange);
                    localVarPath = "/api/v1/roles/{roleId}/data-access/reseller-customers"
                        .replace("{".concat("roleId", "}"), encodeURIComponent(String(roleId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(allOrListChange, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update the role display name and/or description. The access token header should include the login token for the requesting user. If the requesting user is a reseller user updating a role for the customer - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Update role info
         * @param {string} accessToken
         * @param {string} roleId
         * @param {NameAndDescription} nameAndDescription To keep the existing name / description, send null in the relevant field. To delete the existing description, send an empty string as the description.
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoleInfo: function (accessToken_1, roleId_1, nameAndDescription_1, targetOrgToken_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, roleId_1, nameAndDescription_1, targetOrgToken_1], args_1, true), void 0, function (accessToken, roleId, nameAndDescription, targetOrgToken, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('updateRoleInfo', 'accessToken', accessToken);
                    // verify required parameter 'roleId' is not null or undefined
                    (0, common_1.assertParamExists)('updateRoleInfo', 'roleId', roleId);
                    // verify required parameter 'nameAndDescription' is not null or undefined
                    (0, common_1.assertParamExists)('updateRoleInfo', 'nameAndDescription', nameAndDescription);
                    localVarPath = "/api/v1/roles/{roleId}"
                        .replace("{".concat("roleId", "}"), encodeURIComponent(String(roleId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(nameAndDescription, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Add sub roles to an existing role and/or remove sub roles from existing role. The access token header should include the login token for the requesting user. If the requesting user is a reseller user updating a customer role - include also the exchanged token for this customer in the targetOrgToken header. In this case the main role and all its sub roles reside in the customer realm.
         * @summary Add sub roles to role and/or remove sub roles from role
         * @param {string} accessToken
         * @param {string} roleId
         * @param {UpdateSubRolesRequest} updateSubRolesRequest Lists of role ids of sub roles to add / remove
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubRoles: function (accessToken_1, roleId_1, updateSubRolesRequest_1, targetOrgToken_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, roleId_1, updateSubRolesRequest_1, targetOrgToken_1], args_1, true), void 0, function (accessToken, roleId, updateSubRolesRequest, targetOrgToken, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('updateSubRoles', 'accessToken', accessToken);
                    // verify required parameter 'roleId' is not null or undefined
                    (0, common_1.assertParamExists)('updateSubRoles', 'roleId', roleId);
                    // verify required parameter 'updateSubRolesRequest' is not null or undefined
                    (0, common_1.assertParamExists)('updateSubRoles', 'updateSubRolesRequest', updateSubRolesRequest);
                    localVarPath = "/api/v1/roles/{roleId}/sub-roles"
                        .replace("{".concat("roleId", "}"), encodeURIComponent(String(roleId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateSubRolesRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.RolesServiceApiAxiosParamCreator = RolesServiceApiAxiosParamCreator;
/**
 * RolesServiceApi - functional programming interface
 * @export
 */
var RolesServiceApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.RolesServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create a new role in Keycloak. The access token header should include the login token for the requesting user. If the requesting user is a reseller user creating a role for the customer - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Create a role
         * @param {string} accessToken
         * @param {string} [targetOrgToken]
         * @param {Role} [role]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRole: function (accessToken, targetOrgToken, role, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createRole(accessToken, targetOrgToken, role, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RolesServiceApi.createRole']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Batch delete roles. The request body should include a list of role ids to delete. The access token header should include the login token for the requesting user. If the requesting user is a reseller user deleting a customer role - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Delete roles
         * @param {string} accessToken
         * @param {string} [targetOrgToken]
         * @param {Array<string>} [requestBody]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoles: function (accessToken, targetOrgToken, requestBody, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteRoles(accessToken, targetOrgToken, requestBody, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RolesServiceApi.deleteRoles']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * For each category that permissions can be set, get the available actions. Based on the token, the server will return only the relevant categories: system_management will return only for anodot realm, reseller_customers will return only for reseller realms.
         * @summary Get available category actions
         * @param {string} accessToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableCategoryActions: function (accessToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAvailableCategoryActions(accessToken, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RolesServiceApi.getAvailableCategoryActions']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get data access of a role. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing a customer role - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Get data access of role
         * @param {string} accessToken
         * @param {string} roleId
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataAccessOfRole: function (accessToken, roleId, targetOrgToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getDataAccessOfRole(accessToken, roleId, targetOrgToken, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RolesServiceApi.getDataAccessOfRole']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get the merged partial permission details for a set of roles for a given category and action. The request body contain the role ids. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing permissions for customer roles - include also the exchanged token for this customer in the targetOrgToken header. In this case all the roles are expected to be customer roles.
         * @summary Get partial permissions for a set of roles, a category and an action
         * @param {string} accessToken
         * @param {IEntityCategory} category
         * @param {IAction} action
         * @param {Array<string>} requestBody
         * @param {string} [targetOrgToken]
         * @param {string} [paginationToken] The token received in the previous response. if this is the first request - omit.
         * @param {number} [pageSize] Indicates how many entries to return. Must be a positive number or 0. If omitted, a default page size will be used (configurable in properties). If 0 - all entries will be returned (in this case pagination token will be ignored).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMergedPartialPermissionsOfRoles: function (accessToken, category, action, requestBody, targetOrgToken, paginationToken, pageSize, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMergedPartialPermissionsOfRoles(accessToken, category, action, requestBody, targetOrgToken, paginationToken, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RolesServiceApi.getMergedPartialPermissionsOfRoles']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get the merged permissions for a set of roles. The request body contain the role ids. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing permissions for customer roles - include also the exchanged token for this customer in the targetOrgToken header. In this case all the roles are expected to be customer roles.
         * @summary Get permissions for a set of roles
         * @param {string} accessToken
         * @param {Array<string>} requestBody
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMergedPermissionsOfRoles: function (accessToken, requestBody, targetOrgToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getMergedPermissionsOfRoles(accessToken, requestBody, targetOrgToken, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RolesServiceApi.getMergedPermissionsOfRoles']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get partial permission details of a role for a given category and action. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing permissions for a customer role - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Get partial permissions of role, category and action
         * @param {string} accessToken
         * @param {string} roleId
         * @param {IEntityCategory} category
         * @param {IAction} action
         * @param {string} [targetOrgToken]
         * @param {string} [paginationToken] The token received in the previous response. if this is the first request - omit.
         * @param {number} [pageSize] Indicates how many entries to return. Must be a positive number or 0. If omitted, a default page size will be used (configurable in properties). If 0 - all entries will be returned (in this case pagination token will be ignored).
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartialPermissionsOfRole: function (accessToken, roleId, category, action, targetOrgToken, paginationToken, pageSize, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPartialPermissionsOfRole(accessToken, roleId, category, action, targetOrgToken, paginationToken, pageSize, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RolesServiceApi.getPartialPermissionsOfRole']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get all the permissions of a role. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing permissions for a customer - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Get permissions of role
         * @param {string} accessToken
         * @param {string} roleId
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissionsOfRole: function (accessToken, roleId, targetOrgToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPermissionsOfRole(accessToken, roleId, targetOrgToken, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RolesServiceApi.getPermissionsOfRole']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get the role details. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing a customer role - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Get role
         * @param {string} accessToken
         * @param {string} roleId
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRole: function (accessToken, roleId, targetOrgToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRole(accessToken, roleId, targetOrgToken, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RolesServiceApi.getRole']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get users that are assigned to the given role. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing a customer role - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Get users of role
         * @param {string} accessToken
         * @param {string} roleId
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoleUsers: function (accessToken, roleId, targetOrgToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRoleUsers(accessToken, roleId, targetOrgToken, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RolesServiceApi.getRoleUsers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get all the roles, or filter by search string. The access token header should include the login token for the requesting user. If the requesting user is a reseller user listing customer roles - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Get all roles
         * @param {string} accessToken
         * @param {string} [targetOrgToken]
         * @param {string} [search]
         * @param {number} [pageSize] Indicates how many entries to return. Must be a positive number. If omitted, a default page size will be used (configurable in properties).
         * @param {string} [paginationToken] The token received in the previous response. if this is the first request - omit.
         * @param {boolean} [excludeBuiltInRoles]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles: function (accessToken, targetOrgToken, search, pageSize, paginationToken, excludeBuiltInRoles, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getRoles(accessToken, targetOrgToken, search, pageSize, paginationToken, excludeBuiltInRoles, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RolesServiceApi.getRoles']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Set permissions of a role. The access token header should include the login token for the requesting user. If the requesting user is a reseller user updating a customer role - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Set permissions of role
         * @param {string} accessToken
         * @param {string} roleId
         * @param {string} [targetOrgToken]
         * @param {Array<RoleCategoryPermissions>} [roleCategoryPermissions] The request body should include entries only for the modified categories.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPermissionsOfRole: function (accessToken, roleId, targetOrgToken, roleCategoryPermissions, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.setPermissionsOfRole(accessToken, roleId, targetOrgToken, roleCategoryPermissions, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RolesServiceApi.setPermissionsOfRole']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Update the list of cost centers that are accessible for this role. The request should include only the changes from to the current state. The access token header should include the login token for the requesting user. If the requesting user is a reseller user updating a customer role - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Update cost centers accessible by a role
         * @param {string} accessToken
         * @param {string} roleId
         * @param {AllOrListChange} allOrListChange
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCostCentersAccessibleByRole: function (accessToken, roleId, allOrListChange, targetOrgToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateCostCentersAccessibleByRole(accessToken, roleId, allOrListChange, targetOrgToken, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RolesServiceApi.updateCostCentersAccessibleByRole']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Update the list of linked accounts that are accessible for this role. The request should include only the changes from to the current state. The access token header should include the login token for the requesting user. If the requesting user is a reseller user updating a customer role - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Update linked accounts accessible by a role
         * @param {string} accessToken
         * @param {string} roleId
         * @param {UpdateLinkedAccountsAccessibleByRoleRequest} updateLinkedAccountsAccessibleByRoleRequest
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLinkedAccountsAccessibleByRole: function (accessToken, roleId, updateLinkedAccountsAccessibleByRoleRequest, targetOrgToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateLinkedAccountsAccessibleByRole(accessToken, roleId, updateLinkedAccountsAccessibleByRoleRequest, targetOrgToken, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RolesServiceApi.updateLinkedAccountsAccessibleByRole']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Update the list of reseller customers that are accessible for this role. The request should include only the changes from to the current state. The access token header should include the login token for the requesting user.
         * @summary Update reseller customers accessible by a role
         * @param {string} accessToken
         * @param {string} roleId
         * @param {AllOrListChange} allOrListChange
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateResellerCustomersAccessibleByRole: function (accessToken, roleId, allOrListChange, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateResellerCustomersAccessibleByRole(accessToken, roleId, allOrListChange, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RolesServiceApi.updateResellerCustomersAccessibleByRole']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Update the role display name and/or description. The access token header should include the login token for the requesting user. If the requesting user is a reseller user updating a role for the customer - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Update role info
         * @param {string} accessToken
         * @param {string} roleId
         * @param {NameAndDescription} nameAndDescription To keep the existing name / description, send null in the relevant field. To delete the existing description, send an empty string as the description.
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoleInfo: function (accessToken, roleId, nameAndDescription, targetOrgToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateRoleInfo(accessToken, roleId, nameAndDescription, targetOrgToken, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RolesServiceApi.updateRoleInfo']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Add sub roles to an existing role and/or remove sub roles from existing role. The access token header should include the login token for the requesting user. If the requesting user is a reseller user updating a customer role - include also the exchanged token for this customer in the targetOrgToken header. In this case the main role and all its sub roles reside in the customer realm.
         * @summary Add sub roles to role and/or remove sub roles from role
         * @param {string} accessToken
         * @param {string} roleId
         * @param {UpdateSubRolesRequest} updateSubRolesRequest Lists of role ids of sub roles to add / remove
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubRoles: function (accessToken, roleId, updateSubRolesRequest, targetOrgToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateSubRoles(accessToken, roleId, updateSubRolesRequest, targetOrgToken, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['RolesServiceApi.updateSubRoles']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.RolesServiceApiFp = RolesServiceApiFp;
/**
 * RolesServiceApi - factory interface
 * @export
 */
var RolesServiceApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.RolesServiceApiFp)(configuration);
    return {
        /**
         * Create a new role in Keycloak. The access token header should include the login token for the requesting user. If the requesting user is a reseller user creating a role for the customer - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Create a role
         * @param {RolesServiceApiCreateRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRole: function (requestParameters, options) {
            return localVarFp.createRole(requestParameters.accessToken, requestParameters.targetOrgToken, requestParameters.role, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Batch delete roles. The request body should include a list of role ids to delete. The access token header should include the login token for the requesting user. If the requesting user is a reseller user deleting a customer role - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Delete roles
         * @param {RolesServiceApiDeleteRolesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoles: function (requestParameters, options) {
            return localVarFp.deleteRoles(requestParameters.accessToken, requestParameters.targetOrgToken, requestParameters.requestBody, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * For each category that permissions can be set, get the available actions. Based on the token, the server will return only the relevant categories: system_management will return only for anodot realm, reseller_customers will return only for reseller realms.
         * @summary Get available category actions
         * @param {RolesServiceApiGetAvailableCategoryActionsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAvailableCategoryActions: function (requestParameters, options) {
            return localVarFp.getAvailableCategoryActions(requestParameters.accessToken, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get data access of a role. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing a customer role - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Get data access of role
         * @param {RolesServiceApiGetDataAccessOfRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDataAccessOfRole: function (requestParameters, options) {
            return localVarFp.getDataAccessOfRole(requestParameters.accessToken, requestParameters.roleId, requestParameters.targetOrgToken, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the merged partial permission details for a set of roles for a given category and action. The request body contain the role ids. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing permissions for customer roles - include also the exchanged token for this customer in the targetOrgToken header. In this case all the roles are expected to be customer roles.
         * @summary Get partial permissions for a set of roles, a category and an action
         * @param {RolesServiceApiGetMergedPartialPermissionsOfRolesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMergedPartialPermissionsOfRoles: function (requestParameters, options) {
            return localVarFp.getMergedPartialPermissionsOfRoles(requestParameters.accessToken, requestParameters.category, requestParameters.action, requestParameters.requestBody, requestParameters.targetOrgToken, requestParameters.paginationToken, requestParameters.pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the merged permissions for a set of roles. The request body contain the role ids. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing permissions for customer roles - include also the exchanged token for this customer in the targetOrgToken header. In this case all the roles are expected to be customer roles.
         * @summary Get permissions for a set of roles
         * @param {RolesServiceApiGetMergedPermissionsOfRolesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMergedPermissionsOfRoles: function (requestParameters, options) {
            return localVarFp.getMergedPermissionsOfRoles(requestParameters.accessToken, requestParameters.requestBody, requestParameters.targetOrgToken, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get partial permission details of a role for a given category and action. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing permissions for a customer role - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Get partial permissions of role, category and action
         * @param {RolesServiceApiGetPartialPermissionsOfRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartialPermissionsOfRole: function (requestParameters, options) {
            return localVarFp.getPartialPermissionsOfRole(requestParameters.accessToken, requestParameters.roleId, requestParameters.category, requestParameters.action, requestParameters.targetOrgToken, requestParameters.paginationToken, requestParameters.pageSize, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all the permissions of a role. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing permissions for a customer - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Get permissions of role
         * @param {RolesServiceApiGetPermissionsOfRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPermissionsOfRole: function (requestParameters, options) {
            return localVarFp.getPermissionsOfRole(requestParameters.accessToken, requestParameters.roleId, requestParameters.targetOrgToken, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the role details. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing a customer role - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Get role
         * @param {RolesServiceApiGetRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRole: function (requestParameters, options) {
            return localVarFp.getRole(requestParameters.accessToken, requestParameters.roleId, requestParameters.targetOrgToken, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get users that are assigned to the given role. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing a customer role - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Get users of role
         * @param {RolesServiceApiGetRoleUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoleUsers: function (requestParameters, options) {
            return localVarFp.getRoleUsers(requestParameters.accessToken, requestParameters.roleId, requestParameters.targetOrgToken, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all the roles, or filter by search string. The access token header should include the login token for the requesting user. If the requesting user is a reseller user listing customer roles - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Get all roles
         * @param {RolesServiceApiGetRolesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoles: function (requestParameters, options) {
            return localVarFp.getRoles(requestParameters.accessToken, requestParameters.targetOrgToken, requestParameters.search, requestParameters.pageSize, requestParameters.paginationToken, requestParameters.excludeBuiltInRoles, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Set permissions of a role. The access token header should include the login token for the requesting user. If the requesting user is a reseller user updating a customer role - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Set permissions of role
         * @param {RolesServiceApiSetPermissionsOfRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setPermissionsOfRole: function (requestParameters, options) {
            return localVarFp.setPermissionsOfRole(requestParameters.accessToken, requestParameters.roleId, requestParameters.targetOrgToken, requestParameters.roleCategoryPermissions, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update the list of cost centers that are accessible for this role. The request should include only the changes from to the current state. The access token header should include the login token for the requesting user. If the requesting user is a reseller user updating a customer role - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Update cost centers accessible by a role
         * @param {RolesServiceApiUpdateCostCentersAccessibleByRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCostCentersAccessibleByRole: function (requestParameters, options) {
            return localVarFp.updateCostCentersAccessibleByRole(requestParameters.accessToken, requestParameters.roleId, requestParameters.allOrListChange, requestParameters.targetOrgToken, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update the list of linked accounts that are accessible for this role. The request should include only the changes from to the current state. The access token header should include the login token for the requesting user. If the requesting user is a reseller user updating a customer role - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Update linked accounts accessible by a role
         * @param {RolesServiceApiUpdateLinkedAccountsAccessibleByRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLinkedAccountsAccessibleByRole: function (requestParameters, options) {
            return localVarFp.updateLinkedAccountsAccessibleByRole(requestParameters.accessToken, requestParameters.roleId, requestParameters.updateLinkedAccountsAccessibleByRoleRequest, requestParameters.targetOrgToken, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update the list of reseller customers that are accessible for this role. The request should include only the changes from to the current state. The access token header should include the login token for the requesting user.
         * @summary Update reseller customers accessible by a role
         * @param {RolesServiceApiUpdateResellerCustomersAccessibleByRoleRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateResellerCustomersAccessibleByRole: function (requestParameters, options) {
            return localVarFp.updateResellerCustomersAccessibleByRole(requestParameters.accessToken, requestParameters.roleId, requestParameters.allOrListChange, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update the role display name and/or description. The access token header should include the login token for the requesting user. If the requesting user is a reseller user updating a role for the customer - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Update role info
         * @param {RolesServiceApiUpdateRoleInfoRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoleInfo: function (requestParameters, options) {
            return localVarFp.updateRoleInfo(requestParameters.accessToken, requestParameters.roleId, requestParameters.nameAndDescription, requestParameters.targetOrgToken, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Add sub roles to an existing role and/or remove sub roles from existing role. The access token header should include the login token for the requesting user. If the requesting user is a reseller user updating a customer role - include also the exchanged token for this customer in the targetOrgToken header. In this case the main role and all its sub roles reside in the customer realm.
         * @summary Add sub roles to role and/or remove sub roles from role
         * @param {RolesServiceApiUpdateSubRolesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSubRoles: function (requestParameters, options) {
            return localVarFp.updateSubRoles(requestParameters.accessToken, requestParameters.roleId, requestParameters.updateSubRolesRequest, requestParameters.targetOrgToken, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.RolesServiceApiFactory = RolesServiceApiFactory;
/**
 * RolesServiceApi - object-oriented interface
 * @export
 * @class RolesServiceApi
 * @extends {BaseAPI}
 */
var RolesServiceApi = /** @class */ (function (_super) {
    __extends(RolesServiceApi, _super);
    function RolesServiceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a new role in Keycloak. The access token header should include the login token for the requesting user. If the requesting user is a reseller user creating a role for the customer - include also the exchanged token for this customer in the targetOrgToken header.
     * @summary Create a role
     * @param {RolesServiceApiCreateRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesServiceApi
     */
    RolesServiceApi.prototype.createRole = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RolesServiceApiFp)(this.configuration).createRole(requestParameters.accessToken, requestParameters.targetOrgToken, requestParameters.role, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Batch delete roles. The request body should include a list of role ids to delete. The access token header should include the login token for the requesting user. If the requesting user is a reseller user deleting a customer role - include also the exchanged token for this customer in the targetOrgToken header.
     * @summary Delete roles
     * @param {RolesServiceApiDeleteRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesServiceApi
     */
    RolesServiceApi.prototype.deleteRoles = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RolesServiceApiFp)(this.configuration).deleteRoles(requestParameters.accessToken, requestParameters.targetOrgToken, requestParameters.requestBody, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * For each category that permissions can be set, get the available actions. Based on the token, the server will return only the relevant categories: system_management will return only for anodot realm, reseller_customers will return only for reseller realms.
     * @summary Get available category actions
     * @param {RolesServiceApiGetAvailableCategoryActionsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesServiceApi
     */
    RolesServiceApi.prototype.getAvailableCategoryActions = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RolesServiceApiFp)(this.configuration).getAvailableCategoryActions(requestParameters.accessToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get data access of a role. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing a customer role - include also the exchanged token for this customer in the targetOrgToken header.
     * @summary Get data access of role
     * @param {RolesServiceApiGetDataAccessOfRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesServiceApi
     */
    RolesServiceApi.prototype.getDataAccessOfRole = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RolesServiceApiFp)(this.configuration).getDataAccessOfRole(requestParameters.accessToken, requestParameters.roleId, requestParameters.targetOrgToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the merged partial permission details for a set of roles for a given category and action. The request body contain the role ids. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing permissions for customer roles - include also the exchanged token for this customer in the targetOrgToken header. In this case all the roles are expected to be customer roles.
     * @summary Get partial permissions for a set of roles, a category and an action
     * @param {RolesServiceApiGetMergedPartialPermissionsOfRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesServiceApi
     */
    RolesServiceApi.prototype.getMergedPartialPermissionsOfRoles = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RolesServiceApiFp)(this.configuration).getMergedPartialPermissionsOfRoles(requestParameters.accessToken, requestParameters.category, requestParameters.action, requestParameters.requestBody, requestParameters.targetOrgToken, requestParameters.paginationToken, requestParameters.pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the merged permissions for a set of roles. The request body contain the role ids. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing permissions for customer roles - include also the exchanged token for this customer in the targetOrgToken header. In this case all the roles are expected to be customer roles.
     * @summary Get permissions for a set of roles
     * @param {RolesServiceApiGetMergedPermissionsOfRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesServiceApi
     */
    RolesServiceApi.prototype.getMergedPermissionsOfRoles = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RolesServiceApiFp)(this.configuration).getMergedPermissionsOfRoles(requestParameters.accessToken, requestParameters.requestBody, requestParameters.targetOrgToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get partial permission details of a role for a given category and action. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing permissions for a customer role - include also the exchanged token for this customer in the targetOrgToken header.
     * @summary Get partial permissions of role, category and action
     * @param {RolesServiceApiGetPartialPermissionsOfRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesServiceApi
     */
    RolesServiceApi.prototype.getPartialPermissionsOfRole = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RolesServiceApiFp)(this.configuration).getPartialPermissionsOfRole(requestParameters.accessToken, requestParameters.roleId, requestParameters.category, requestParameters.action, requestParameters.targetOrgToken, requestParameters.paginationToken, requestParameters.pageSize, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all the permissions of a role. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing permissions for a customer - include also the exchanged token for this customer in the targetOrgToken header.
     * @summary Get permissions of role
     * @param {RolesServiceApiGetPermissionsOfRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesServiceApi
     */
    RolesServiceApi.prototype.getPermissionsOfRole = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RolesServiceApiFp)(this.configuration).getPermissionsOfRole(requestParameters.accessToken, requestParameters.roleId, requestParameters.targetOrgToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the role details. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing a customer role - include also the exchanged token for this customer in the targetOrgToken header.
     * @summary Get role
     * @param {RolesServiceApiGetRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesServiceApi
     */
    RolesServiceApi.prototype.getRole = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RolesServiceApiFp)(this.configuration).getRole(requestParameters.accessToken, requestParameters.roleId, requestParameters.targetOrgToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get users that are assigned to the given role. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing a customer role - include also the exchanged token for this customer in the targetOrgToken header.
     * @summary Get users of role
     * @param {RolesServiceApiGetRoleUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesServiceApi
     */
    RolesServiceApi.prototype.getRoleUsers = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RolesServiceApiFp)(this.configuration).getRoleUsers(requestParameters.accessToken, requestParameters.roleId, requestParameters.targetOrgToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all the roles, or filter by search string. The access token header should include the login token for the requesting user. If the requesting user is a reseller user listing customer roles - include also the exchanged token for this customer in the targetOrgToken header.
     * @summary Get all roles
     * @param {RolesServiceApiGetRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesServiceApi
     */
    RolesServiceApi.prototype.getRoles = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RolesServiceApiFp)(this.configuration).getRoles(requestParameters.accessToken, requestParameters.targetOrgToken, requestParameters.search, requestParameters.pageSize, requestParameters.paginationToken, requestParameters.excludeBuiltInRoles, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Set permissions of a role. The access token header should include the login token for the requesting user. If the requesting user is a reseller user updating a customer role - include also the exchanged token for this customer in the targetOrgToken header.
     * @summary Set permissions of role
     * @param {RolesServiceApiSetPermissionsOfRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesServiceApi
     */
    RolesServiceApi.prototype.setPermissionsOfRole = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RolesServiceApiFp)(this.configuration).setPermissionsOfRole(requestParameters.accessToken, requestParameters.roleId, requestParameters.targetOrgToken, requestParameters.roleCategoryPermissions, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update the list of cost centers that are accessible for this role. The request should include only the changes from to the current state. The access token header should include the login token for the requesting user. If the requesting user is a reseller user updating a customer role - include also the exchanged token for this customer in the targetOrgToken header.
     * @summary Update cost centers accessible by a role
     * @param {RolesServiceApiUpdateCostCentersAccessibleByRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesServiceApi
     */
    RolesServiceApi.prototype.updateCostCentersAccessibleByRole = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RolesServiceApiFp)(this.configuration).updateCostCentersAccessibleByRole(requestParameters.accessToken, requestParameters.roleId, requestParameters.allOrListChange, requestParameters.targetOrgToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update the list of linked accounts that are accessible for this role. The request should include only the changes from to the current state. The access token header should include the login token for the requesting user. If the requesting user is a reseller user updating a customer role - include also the exchanged token for this customer in the targetOrgToken header.
     * @summary Update linked accounts accessible by a role
     * @param {RolesServiceApiUpdateLinkedAccountsAccessibleByRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesServiceApi
     */
    RolesServiceApi.prototype.updateLinkedAccountsAccessibleByRole = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RolesServiceApiFp)(this.configuration).updateLinkedAccountsAccessibleByRole(requestParameters.accessToken, requestParameters.roleId, requestParameters.updateLinkedAccountsAccessibleByRoleRequest, requestParameters.targetOrgToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update the list of reseller customers that are accessible for this role. The request should include only the changes from to the current state. The access token header should include the login token for the requesting user.
     * @summary Update reseller customers accessible by a role
     * @param {RolesServiceApiUpdateResellerCustomersAccessibleByRoleRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesServiceApi
     */
    RolesServiceApi.prototype.updateResellerCustomersAccessibleByRole = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RolesServiceApiFp)(this.configuration).updateResellerCustomersAccessibleByRole(requestParameters.accessToken, requestParameters.roleId, requestParameters.allOrListChange, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update the role display name and/or description. The access token header should include the login token for the requesting user. If the requesting user is a reseller user updating a role for the customer - include also the exchanged token for this customer in the targetOrgToken header.
     * @summary Update role info
     * @param {RolesServiceApiUpdateRoleInfoRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesServiceApi
     */
    RolesServiceApi.prototype.updateRoleInfo = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RolesServiceApiFp)(this.configuration).updateRoleInfo(requestParameters.accessToken, requestParameters.roleId, requestParameters.nameAndDescription, requestParameters.targetOrgToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Add sub roles to an existing role and/or remove sub roles from existing role. The access token header should include the login token for the requesting user. If the requesting user is a reseller user updating a customer role - include also the exchanged token for this customer in the targetOrgToken header. In this case the main role and all its sub roles reside in the customer realm.
     * @summary Add sub roles to role and/or remove sub roles from role
     * @param {RolesServiceApiUpdateSubRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RolesServiceApi
     */
    RolesServiceApi.prototype.updateSubRoles = function (requestParameters, options) {
        var _this = this;
        return (0, exports.RolesServiceApiFp)(this.configuration).updateSubRoles(requestParameters.accessToken, requestParameters.roleId, requestParameters.updateSubRolesRequest, requestParameters.targetOrgToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return RolesServiceApi;
}(base_1.BaseAPI));
exports.RolesServiceApi = RolesServiceApi;
/**
 * TokensServiceApi - axios parameter creator
 * @export
 */
var TokensServiceApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Get access and refresh tokens for the given organization, which is a reseller customer of the current organization
         * @summary Get token for customer
         * @param {string} accessToken
         * @param {string} resellerCustomerOrgId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerOrgToken: function (accessToken_1, resellerCustomerOrgId_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, resellerCustomerOrgId_1], args_1, true), void 0, function (accessToken, resellerCustomerOrgId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('getCustomerOrgToken', 'accessToken', accessToken);
                    // verify required parameter 'resellerCustomerOrgId' is not null or undefined
                    (0, common_1.assertParamExists)('getCustomerOrgToken', 'resellerCustomerOrgId', resellerCustomerOrgId);
                    localVarPath = "/api/v1/customer-token";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (resellerCustomerOrgId !== undefined) {
                        localVarQueryParameter['resellerCustomerOrgId'] = resellerCustomerOrgId;
                    }
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get an access token to execute the forecast task using the appropriate client in Anodot realm.
         * @summary Get an access token to execute the forecast task
         * @param {string} [clientSecret] The secret to use to connect to the requested client. The secret should be encrypted by the predefined encryption key.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForecastTaskToken: function (clientSecret_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([clientSecret_1], args_1, true), void 0, function (clientSecret, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/forecast-token";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (clientSecret != null) {
                        localVarHeaderParameter['ClientSecret'] = String(clientSecret);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get an access token to execute an offline task such as report, budget, etc.. The resulting token will have only the permissions of the user that\'s defined as the executor of this task.
         * @summary Get an access token to execute an offline task
         * @param {string} taskOrgUuid
         * @param {IEntityCategory} category
         * @param {string} taskId
         * @param {string} [clientSecret] The secret to use to connect to the requested client. The secret should be encrypted by the predefined encryption key.
         * @param {string} [clientSecret2] The secret to use to connect to the offline tasks client. The secret should be encrypted by the predefined encryption key.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfflineTaskToken: function (taskOrgUuid_1, category_1, taskId_1, clientSecret_1, clientSecret2_1) {
            var args_1 = [];
            for (var _i = 5; _i < arguments.length; _i++) {
                args_1[_i - 5] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([taskOrgUuid_1, category_1, taskId_1, clientSecret_1, clientSecret2_1], args_1, true), void 0, function (taskOrgUuid, category, taskId, clientSecret, clientSecret2, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'taskOrgUuid' is not null or undefined
                    (0, common_1.assertParamExists)('getOfflineTaskToken', 'taskOrgUuid', taskOrgUuid);
                    // verify required parameter 'category' is not null or undefined
                    (0, common_1.assertParamExists)('getOfflineTaskToken', 'category', category);
                    // verify required parameter 'taskId' is not null or undefined
                    (0, common_1.assertParamExists)('getOfflineTaskToken', 'taskId', taskId);
                    localVarPath = "/api/v1/offline-tasks/{taskOrgUuid}/{category}/{taskId}/token"
                        .replace("{".concat("taskOrgUuid", "}"), encodeURIComponent(String(taskOrgUuid)))
                        .replace("{".concat("category", "}"), encodeURIComponent(String(category)))
                        .replace("{".concat("taskId", "}"), encodeURIComponent(String(taskId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (clientSecret2 !== undefined) {
                        localVarQueryParameter['clientSecret'] = clientSecret2;
                    }
                    if (clientSecret != null) {
                        localVarHeaderParameter['ClientSecret'] = String(clientSecret);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all reseller tokens for the organization authorized by the given token
         * @summary Get tokens for Resellers
         * @param {string} accessToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResellerTokens: function (accessToken_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1], args_1, true), void 0, function (accessToken, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('getResellerTokens', 'accessToken', accessToken);
                    localVarPath = "/api/v1/reseller-tokens";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get an access token to execute system management tasks using the appropriate client in Anodot realm. The permissions that the resulting token grants are all actions for categories accounts and reseller_customers categories, and a full data access for all organizations.
         * @summary Get an access token to execute system management tasks
         * @param {string} [clientSecret] The secret to use to connect to the requested client. The secret should be encrypted by the predefined encryption key.
         * @param {string} [clientSecret2] The secret to use to connect to the system management client. The secret should be encrypted by the predefined encryption key.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSystemManagementClientToken: function (clientSecret_1, clientSecret2_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([clientSecret_1, clientSecret2_1], args_1, true), void 0, function (clientSecret, clientSecret2, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/system-management-client-token";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (clientSecret2 !== undefined) {
                        localVarQueryParameter['clientSecret'] = clientSecret2;
                    }
                    if (clientSecret != null) {
                        localVarHeaderParameter['ClientSecret'] = String(clientSecret);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get an access token that allows impersonating as the given user. If this is a reseller user requesting to impersonate as a customer user, include the customer token in the targetOrgToken header.
         * @summary Impersonate as the given user
         * @param {string} accessToken
         * @param {string} userId
         * @param {string} [targetOrgToken]
         * @param {string} [userOrgUuid] If the current user is from anodot realm, and they want to impersonate a user from a different realm, they should provide the user\&#39;s organization uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impersonate: function (accessToken_1, userId_1, targetOrgToken_1, userOrgUuid_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, userId_1, targetOrgToken_1, userOrgUuid_1], args_1, true), void 0, function (accessToken, userId, targetOrgToken, userOrgUuid, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('impersonate', 'accessToken', accessToken);
                    // verify required parameter 'userId' is not null or undefined
                    (0, common_1.assertParamExists)('impersonate', 'userId', userId);
                    localVarPath = "/api/vi/impersonation-token";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (userId !== undefined) {
                        localVarQueryParameter['userId'] = userId;
                    }
                    if (userOrgUuid !== undefined) {
                        localVarQueryParameter['userOrgUuid'] = userOrgUuid;
                    }
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Revoke all the given customer tokens
         * @summary Revoke customer tokens
         * @param {Array<OrgTokens>} [orgTokens]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutCustomerTokens: function (orgTokens_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([orgTokens_1], args_1, true), void 0, function (orgTokens, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/customer-tokens/logout";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(orgTokens, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Revoke impersonation token
         * @summary Revoke impersonation token
         * @param {OrgTokens} [orgTokens]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutImpersonationToken: function (orgTokens_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([orgTokens_1], args_1, true), void 0, function (orgTokens, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/impersonation-token/logout";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(orgTokens, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Revoke all the given reseller tokens
         * @summary Revoke Reseller tokens
         * @param {Array<OrgTokens>} [orgTokens]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutResellerTokens: function (orgTokens_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([orgTokens_1], args_1, true), void 0, function (orgTokens, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/reseller-tokens/logout";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(orgTokens, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Refresh the given access token, using the given refresh token for the given organization, which is a reseller customer of the current organization
         * @summary Refresh token for customer
         * @param {OrgTokens} [orgTokens]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshCustomerOrgToken: function (orgTokens_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([orgTokens_1], args_1, true), void 0, function (orgTokens, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/customer-token/refresh";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(orgTokens, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Refresh the given impersonation token, using the given refresh token
         * @summary Refresh impersonation token
         * @param {OrgTokens} [orgTokens]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshImpersonationToken: function (orgTokens_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([orgTokens_1], args_1, true), void 0, function (orgTokens, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/impersonation-token/refresh";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(orgTokens, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Refresh all the given reseller tokens
         * @summary Refresh tokens for Resellers
         * @param {Array<OrgTokens>} [orgTokens]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshResellerTokens: function (orgTokens_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([orgTokens_1], args_1, true), void 0, function (orgTokens, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    localVarPath = "/api/v1/reseller-tokens/refresh";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(orgTokens, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.TokensServiceApiAxiosParamCreator = TokensServiceApiAxiosParamCreator;
/**
 * TokensServiceApi - functional programming interface
 * @export
 */
var TokensServiceApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.TokensServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         * Get access and refresh tokens for the given organization, which is a reseller customer of the current organization
         * @summary Get token for customer
         * @param {string} accessToken
         * @param {string} resellerCustomerOrgId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerOrgToken: function (accessToken, resellerCustomerOrgId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getCustomerOrgToken(accessToken, resellerCustomerOrgId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TokensServiceApi.getCustomerOrgToken']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get an access token to execute the forecast task using the appropriate client in Anodot realm.
         * @summary Get an access token to execute the forecast task
         * @param {string} [clientSecret] The secret to use to connect to the requested client. The secret should be encrypted by the predefined encryption key.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForecastTaskToken: function (clientSecret, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getForecastTaskToken(clientSecret, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TokensServiceApi.getForecastTaskToken']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get an access token to execute an offline task such as report, budget, etc.. The resulting token will have only the permissions of the user that\'s defined as the executor of this task.
         * @summary Get an access token to execute an offline task
         * @param {string} taskOrgUuid
         * @param {IEntityCategory} category
         * @param {string} taskId
         * @param {string} [clientSecret] The secret to use to connect to the requested client. The secret should be encrypted by the predefined encryption key.
         * @param {string} [clientSecret2] The secret to use to connect to the offline tasks client. The secret should be encrypted by the predefined encryption key.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfflineTaskToken: function (taskOrgUuid, category, taskId, clientSecret, clientSecret2, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getOfflineTaskToken(taskOrgUuid, category, taskId, clientSecret, clientSecret2, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TokensServiceApi.getOfflineTaskToken']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get all reseller tokens for the organization authorized by the given token
         * @summary Get tokens for Resellers
         * @param {string} accessToken
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResellerTokens: function (accessToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getResellerTokens(accessToken, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TokensServiceApi.getResellerTokens']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get an access token to execute system management tasks using the appropriate client in Anodot realm. The permissions that the resulting token grants are all actions for categories accounts and reseller_customers categories, and a full data access for all organizations.
         * @summary Get an access token to execute system management tasks
         * @param {string} [clientSecret] The secret to use to connect to the requested client. The secret should be encrypted by the predefined encryption key.
         * @param {string} [clientSecret2] The secret to use to connect to the system management client. The secret should be encrypted by the predefined encryption key.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSystemManagementClientToken: function (clientSecret, clientSecret2, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getSystemManagementClientToken(clientSecret, clientSecret2, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TokensServiceApi.getSystemManagementClientToken']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get an access token that allows impersonating as the given user. If this is a reseller user requesting to impersonate as a customer user, include the customer token in the targetOrgToken header.
         * @summary Impersonate as the given user
         * @param {string} accessToken
         * @param {string} userId
         * @param {string} [targetOrgToken]
         * @param {string} [userOrgUuid] If the current user is from anodot realm, and they want to impersonate a user from a different realm, they should provide the user\&#39;s organization uuid
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impersonate: function (accessToken, userId, targetOrgToken, userOrgUuid, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.impersonate(accessToken, userId, targetOrgToken, userOrgUuid, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TokensServiceApi.impersonate']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Revoke all the given customer tokens
         * @summary Revoke customer tokens
         * @param {Array<OrgTokens>} [orgTokens]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutCustomerTokens: function (orgTokens, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.logoutCustomerTokens(orgTokens, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TokensServiceApi.logoutCustomerTokens']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Revoke impersonation token
         * @summary Revoke impersonation token
         * @param {OrgTokens} [orgTokens]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutImpersonationToken: function (orgTokens, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.logoutImpersonationToken(orgTokens, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TokensServiceApi.logoutImpersonationToken']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Revoke all the given reseller tokens
         * @summary Revoke Reseller tokens
         * @param {Array<OrgTokens>} [orgTokens]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutResellerTokens: function (orgTokens, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.logoutResellerTokens(orgTokens, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TokensServiceApi.logoutResellerTokens']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Refresh the given access token, using the given refresh token for the given organization, which is a reseller customer of the current organization
         * @summary Refresh token for customer
         * @param {OrgTokens} [orgTokens]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshCustomerOrgToken: function (orgTokens, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.refreshCustomerOrgToken(orgTokens, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TokensServiceApi.refreshCustomerOrgToken']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Refresh the given impersonation token, using the given refresh token
         * @summary Refresh impersonation token
         * @param {OrgTokens} [orgTokens]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshImpersonationToken: function (orgTokens, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.refreshImpersonationToken(orgTokens, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TokensServiceApi.refreshImpersonationToken']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Refresh all the given reseller tokens
         * @summary Refresh tokens for Resellers
         * @param {Array<OrgTokens>} [orgTokens]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshResellerTokens: function (orgTokens, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.refreshResellerTokens(orgTokens, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['TokensServiceApi.refreshResellerTokens']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.TokensServiceApiFp = TokensServiceApiFp;
/**
 * TokensServiceApi - factory interface
 * @export
 */
var TokensServiceApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.TokensServiceApiFp)(configuration);
    return {
        /**
         * Get access and refresh tokens for the given organization, which is a reseller customer of the current organization
         * @summary Get token for customer
         * @param {TokensServiceApiGetCustomerOrgTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCustomerOrgToken: function (requestParameters, options) {
            return localVarFp.getCustomerOrgToken(requestParameters.accessToken, requestParameters.resellerCustomerOrgId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get an access token to execute the forecast task using the appropriate client in Anodot realm.
         * @summary Get an access token to execute the forecast task
         * @param {TokensServiceApiGetForecastTaskTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getForecastTaskToken: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.getForecastTaskToken(requestParameters.clientSecret, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get an access token to execute an offline task such as report, budget, etc.. The resulting token will have only the permissions of the user that\'s defined as the executor of this task.
         * @summary Get an access token to execute an offline task
         * @param {TokensServiceApiGetOfflineTaskTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOfflineTaskToken: function (requestParameters, options) {
            return localVarFp.getOfflineTaskToken(requestParameters.taskOrgUuid, requestParameters.category, requestParameters.taskId, requestParameters.clientSecret, requestParameters.clientSecret2, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all reseller tokens for the organization authorized by the given token
         * @summary Get tokens for Resellers
         * @param {TokensServiceApiGetResellerTokensRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getResellerTokens: function (requestParameters, options) {
            return localVarFp.getResellerTokens(requestParameters.accessToken, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get an access token to execute system management tasks using the appropriate client in Anodot realm. The permissions that the resulting token grants are all actions for categories accounts and reseller_customers categories, and a full data access for all organizations.
         * @summary Get an access token to execute system management tasks
         * @param {TokensServiceApiGetSystemManagementClientTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSystemManagementClientToken: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.getSystemManagementClientToken(requestParameters.clientSecret, requestParameters.clientSecret2, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get an access token that allows impersonating as the given user. If this is a reseller user requesting to impersonate as a customer user, include the customer token in the targetOrgToken header.
         * @summary Impersonate as the given user
         * @param {TokensServiceApiImpersonateRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        impersonate: function (requestParameters, options) {
            return localVarFp.impersonate(requestParameters.accessToken, requestParameters.userId, requestParameters.targetOrgToken, requestParameters.userOrgUuid, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Revoke all the given customer tokens
         * @summary Revoke customer tokens
         * @param {TokensServiceApiLogoutCustomerTokensRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutCustomerTokens: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.logoutCustomerTokens(requestParameters.orgTokens, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Revoke impersonation token
         * @summary Revoke impersonation token
         * @param {TokensServiceApiLogoutImpersonationTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutImpersonationToken: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.logoutImpersonationToken(requestParameters.orgTokens, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Revoke all the given reseller tokens
         * @summary Revoke Reseller tokens
         * @param {TokensServiceApiLogoutResellerTokensRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        logoutResellerTokens: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.logoutResellerTokens(requestParameters.orgTokens, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Refresh the given access token, using the given refresh token for the given organization, which is a reseller customer of the current organization
         * @summary Refresh token for customer
         * @param {TokensServiceApiRefreshCustomerOrgTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshCustomerOrgToken: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.refreshCustomerOrgToken(requestParameters.orgTokens, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Refresh the given impersonation token, using the given refresh token
         * @summary Refresh impersonation token
         * @param {TokensServiceApiRefreshImpersonationTokenRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshImpersonationToken: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.refreshImpersonationToken(requestParameters.orgTokens, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Refresh all the given reseller tokens
         * @summary Refresh tokens for Resellers
         * @param {TokensServiceApiRefreshResellerTokensRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        refreshResellerTokens: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.refreshResellerTokens(requestParameters.orgTokens, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.TokensServiceApiFactory = TokensServiceApiFactory;
/**
 * TokensServiceApi - object-oriented interface
 * @export
 * @class TokensServiceApi
 * @extends {BaseAPI}
 */
var TokensServiceApi = /** @class */ (function (_super) {
    __extends(TokensServiceApi, _super);
    function TokensServiceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Get access and refresh tokens for the given organization, which is a reseller customer of the current organization
     * @summary Get token for customer
     * @param {TokensServiceApiGetCustomerOrgTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokensServiceApi
     */
    TokensServiceApi.prototype.getCustomerOrgToken = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TokensServiceApiFp)(this.configuration).getCustomerOrgToken(requestParameters.accessToken, requestParameters.resellerCustomerOrgId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get an access token to execute the forecast task using the appropriate client in Anodot realm.
     * @summary Get an access token to execute the forecast task
     * @param {TokensServiceApiGetForecastTaskTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokensServiceApi
     */
    TokensServiceApi.prototype.getForecastTaskToken = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.TokensServiceApiFp)(this.configuration).getForecastTaskToken(requestParameters.clientSecret, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get an access token to execute an offline task such as report, budget, etc.. The resulting token will have only the permissions of the user that\'s defined as the executor of this task.
     * @summary Get an access token to execute an offline task
     * @param {TokensServiceApiGetOfflineTaskTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokensServiceApi
     */
    TokensServiceApi.prototype.getOfflineTaskToken = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TokensServiceApiFp)(this.configuration).getOfflineTaskToken(requestParameters.taskOrgUuid, requestParameters.category, requestParameters.taskId, requestParameters.clientSecret, requestParameters.clientSecret2, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all reseller tokens for the organization authorized by the given token
     * @summary Get tokens for Resellers
     * @param {TokensServiceApiGetResellerTokensRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokensServiceApi
     */
    TokensServiceApi.prototype.getResellerTokens = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TokensServiceApiFp)(this.configuration).getResellerTokens(requestParameters.accessToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get an access token to execute system management tasks using the appropriate client in Anodot realm. The permissions that the resulting token grants are all actions for categories accounts and reseller_customers categories, and a full data access for all organizations.
     * @summary Get an access token to execute system management tasks
     * @param {TokensServiceApiGetSystemManagementClientTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokensServiceApi
     */
    TokensServiceApi.prototype.getSystemManagementClientToken = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.TokensServiceApiFp)(this.configuration).getSystemManagementClientToken(requestParameters.clientSecret, requestParameters.clientSecret2, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get an access token that allows impersonating as the given user. If this is a reseller user requesting to impersonate as a customer user, include the customer token in the targetOrgToken header.
     * @summary Impersonate as the given user
     * @param {TokensServiceApiImpersonateRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokensServiceApi
     */
    TokensServiceApi.prototype.impersonate = function (requestParameters, options) {
        var _this = this;
        return (0, exports.TokensServiceApiFp)(this.configuration).impersonate(requestParameters.accessToken, requestParameters.userId, requestParameters.targetOrgToken, requestParameters.userOrgUuid, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Revoke all the given customer tokens
     * @summary Revoke customer tokens
     * @param {TokensServiceApiLogoutCustomerTokensRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokensServiceApi
     */
    TokensServiceApi.prototype.logoutCustomerTokens = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.TokensServiceApiFp)(this.configuration).logoutCustomerTokens(requestParameters.orgTokens, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Revoke impersonation token
     * @summary Revoke impersonation token
     * @param {TokensServiceApiLogoutImpersonationTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokensServiceApi
     */
    TokensServiceApi.prototype.logoutImpersonationToken = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.TokensServiceApiFp)(this.configuration).logoutImpersonationToken(requestParameters.orgTokens, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Revoke all the given reseller tokens
     * @summary Revoke Reseller tokens
     * @param {TokensServiceApiLogoutResellerTokensRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokensServiceApi
     */
    TokensServiceApi.prototype.logoutResellerTokens = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.TokensServiceApiFp)(this.configuration).logoutResellerTokens(requestParameters.orgTokens, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Refresh the given access token, using the given refresh token for the given organization, which is a reseller customer of the current organization
     * @summary Refresh token for customer
     * @param {TokensServiceApiRefreshCustomerOrgTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokensServiceApi
     */
    TokensServiceApi.prototype.refreshCustomerOrgToken = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.TokensServiceApiFp)(this.configuration).refreshCustomerOrgToken(requestParameters.orgTokens, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Refresh the given impersonation token, using the given refresh token
     * @summary Refresh impersonation token
     * @param {TokensServiceApiRefreshImpersonationTokenRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokensServiceApi
     */
    TokensServiceApi.prototype.refreshImpersonationToken = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.TokensServiceApiFp)(this.configuration).refreshImpersonationToken(requestParameters.orgTokens, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Refresh all the given reseller tokens
     * @summary Refresh tokens for Resellers
     * @param {TokensServiceApiRefreshResellerTokensRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokensServiceApi
     */
    TokensServiceApi.prototype.refreshResellerTokens = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.TokensServiceApiFp)(this.configuration).refreshResellerTokens(requestParameters.orgTokens, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return TokensServiceApi;
}(base_1.BaseAPI));
exports.TokensServiceApi = TokensServiceApi;
/**
 * UsersServiceApi - axios parameter creator
 * @export
 */
var UsersServiceApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         * Create new users in a single realm in Keycloak. The access token header should include the login token for the requesting user. If the requesting user is a reseller user creating users for a customer - include also the exchanged token for this customer in the targetOrgToken header. **Note: creating a user does not set its roles.**
         * @summary Create users
         * @param {string} accessToken
         * @param {Array<User>} user
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUsers: function (accessToken_1, user_1, targetOrgToken_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, user_1, targetOrgToken_1], args_1, true), void 0, function (accessToken, user, targetOrgToken, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('createUsers', 'accessToken', accessToken);
                    // verify required parameter 'user' is not null or undefined
                    (0, common_1.assertParamExists)('createUsers', 'user', user);
                    localVarPath = "/api/v1/users";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(user, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Batch delete users. The access token header should include the login token for the requesting user. If the requesting user is a reseller user deleting customer users - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Delete users
         * @param {string} accessToken
         * @param {Array<string>} requestBody
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUsers: function (accessToken_1, requestBody_1, targetOrgToken_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, requestBody_1, targetOrgToken_1], args_1, true), void 0, function (accessToken, requestBody, targetOrgToken, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('deleteUsers', 'accessToken', accessToken);
                    // verify required parameter 'requestBody' is not null or undefined
                    (0, common_1.assertParamExists)('deleteUsers', 'requestBody', requestBody);
                    localVarPath = "/api/v1/users";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'DELETE' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Download all the users, or the selected users. The access token header should include the login token for the requesting user. If the requesting user is a reseller user downloading customer users - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Download users
         * @param {string} accessToken
         * @param {string} [targetOrgToken]
         * @param {string} [paginationToken] The token received in the previous response. if this is the first request - omit.
         * @param {number} [pageSize] Indicates how many entries to return. Must be a positive number. If omitted, a default page size will be used (configurable in properties).
         * @param {DownloadUsersRequest} [downloadUsersRequest] List of user ids to download. If empty or null - download all users that the requesting user is allowed to view
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadUsers: function (accessToken_1, targetOrgToken_1, paginationToken_1, pageSize_1, downloadUsersRequest_1) {
            var args_1 = [];
            for (var _i = 5; _i < arguments.length; _i++) {
                args_1[_i - 5] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, targetOrgToken_1, paginationToken_1, pageSize_1, downloadUsersRequest_1], args_1, true), void 0, function (accessToken, targetOrgToken, paginationToken, pageSize, downloadUsersRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('downloadUsers', 'accessToken', accessToken);
                    localVarPath = "/api/v1/users/download";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (paginationToken !== undefined) {
                        localVarQueryParameter['paginationToken'] = paginationToken;
                    }
                    if (pageSize !== undefined) {
                        localVarQueryParameter['pageSize'] = pageSize;
                    }
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(downloadUsersRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Batch enable or disable users. The access token header should include the login token for the requesting user. If the requesting user is a reseller user updating customer users - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Enable or Disable users
         * @param {string} accessToken
         * @param {boolean} enable true to enable, false to disable
         * @param {Array<string>} requestBody
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableUsers: function (accessToken_1, enable_1, requestBody_1, targetOrgToken_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, enable_1, requestBody_1, targetOrgToken_1], args_1, true), void 0, function (accessToken, enable, requestBody, targetOrgToken, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('enableUsers', 'accessToken', accessToken);
                    // verify required parameter 'enable' is not null or undefined
                    (0, common_1.assertParamExists)('enableUsers', 'enable', enable);
                    // verify required parameter 'requestBody' is not null or undefined
                    (0, common_1.assertParamExists)('enableUsers', 'requestBody', requestBody);
                    localVarPath = "/api/v1/users/enable-disable";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (enable !== undefined) {
                        localVarQueryParameter['enable'] = enable;
                    }
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all the users, from all organizations, or filter by search string. Send pageSize = -1 to get ALL users. The access token header should include the login token for the requesting user. The requesting user should have system management permissions.
         * @summary Get all users from all organizations
         * @param {string} accessToken
         * @param {string} [search]
         * @param {number} [pageSize] Indicates how many entries to return. Must be a positive number. If omitted, a default page size will be used (configurable in properties).
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsersInSystem: function (accessToken_1, search_1, pageSize_1, offset_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, search_1, pageSize_1, offset_1], args_1, true), void 0, function (accessToken, search, pageSize, offset, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('getAllUsersInSystem', 'accessToken', accessToken);
                    localVarPath = "/api/v1/system/users";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (search !== undefined) {
                        localVarQueryParameter['search'] = search;
                    }
                    if (pageSize !== undefined) {
                        localVarQueryParameter['pageSize'] = pageSize;
                    }
                    if (offset !== undefined) {
                        localVarQueryParameter['offset'] = offset;
                    }
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get partial permission details of a user for given category and action. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing permissions for a customer user - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Get partial permissions of user
         * @param {string} accessToken
         * @param {string} userId
         * @param {IEntityCategory} category
         * @param {IAction} action
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartialPermissionsOfUser: function (accessToken_1, userId_1, category_1, action_1, targetOrgToken_1) {
            var args_1 = [];
            for (var _i = 5; _i < arguments.length; _i++) {
                args_1[_i - 5] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, userId_1, category_1, action_1, targetOrgToken_1], args_1, true), void 0, function (accessToken, userId, category, action, targetOrgToken, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('getPartialPermissionsOfUser', 'accessToken', accessToken);
                    // verify required parameter 'userId' is not null or undefined
                    (0, common_1.assertParamExists)('getPartialPermissionsOfUser', 'userId', userId);
                    // verify required parameter 'category' is not null or undefined
                    (0, common_1.assertParamExists)('getPartialPermissionsOfUser', 'category', category);
                    // verify required parameter 'action' is not null or undefined
                    (0, common_1.assertParamExists)('getPartialPermissionsOfUser', 'action', action);
                    localVarPath = "/api/v1/users/{userId}/permissions/{category}/{action}"
                        .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)))
                        .replace("{".concat("category", "}"), encodeURIComponent(String(category)))
                        .replace("{".concat("action", "}"), encodeURIComponent(String(action)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get the user details. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing a customer user - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Get user
         * @param {string} accessToken
         * @param {string} userId
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: function (accessToken_1, userId_1, targetOrgToken_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, userId_1, targetOrgToken_1], args_1, true), void 0, function (accessToken, userId, targetOrgToken, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('getUser', 'accessToken', accessToken);
                    // verify required parameter 'userId' is not null or undefined
                    (0, common_1.assertParamExists)('getUser', 'userId', userId);
                    localVarPath = "/api/v1/users/{userId}"
                        .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Get all the users, or filter by search string. Send pageSize = -1 to get ALL users. The access token header should include the login token for the requesting user.If the requesting user is a reseller user viewing customer users - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Get all users
         * @param {string} accessToken
         * @param {string} [targetOrgToken]
         * @param {string} [search]
         * @param {number} [pageSize] Indicates how many entries to return. Must be a positive number. If omitted, a default page size will be used (configurable in properties).
         * @param {string} [paginationToken] The token received in the previous response. if this is the first request - omit.
         * @param {string} [username] Search expression to filter only by username
         * @param {string} [firstName] Search expression to filter only by first name
         * @param {string} [lastName] Search expression to filter only by last name
         * @param {string} [roles] Search expression to filter only by roles
         * @param {string} [createdAt] Search expression to filter only by creation date, format: yyyy-MM-dd
         * @param {DateFilterType} [createdAtFilterType] if createdAt filter is provided, this parameter indicates how to use it. If missing, server will use default - EQUALS
         * @param {string} [lastLogin] Search expression to filter only by last login date, format: yyyy-MM-dd
         * @param {DateFilterType} [lastLoginFilterType] if lastLogin filter is provided, this parameter indicates how to use it. If missing, server will use default - EQUALS
         * @param {boolean} [enabled] Search expression to filter only by enabled status: if true - return only enabled. If false - return only disabled. If omitted - return both
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: function (accessToken_1, targetOrgToken_1, search_1, pageSize_1, paginationToken_1, username_1, firstName_1, lastName_1, roles_1, createdAt_1, createdAtFilterType_1, lastLogin_1, lastLoginFilterType_1, enabled_1) {
            var args_1 = [];
            for (var _i = 14; _i < arguments.length; _i++) {
                args_1[_i - 14] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, targetOrgToken_1, search_1, pageSize_1, paginationToken_1, username_1, firstName_1, lastName_1, roles_1, createdAt_1, createdAtFilterType_1, lastLogin_1, lastLoginFilterType_1, enabled_1], args_1, true), void 0, function (accessToken, targetOrgToken, search, pageSize, paginationToken, username, firstName, lastName, roles, createdAt, createdAtFilterType, lastLogin, lastLoginFilterType, enabled, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('getUsers', 'accessToken', accessToken);
                    localVarPath = "/api/v1/users";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (search !== undefined) {
                        localVarQueryParameter['search'] = search;
                    }
                    if (pageSize !== undefined) {
                        localVarQueryParameter['pageSize'] = pageSize;
                    }
                    if (paginationToken !== undefined) {
                        localVarQueryParameter['paginationToken'] = paginationToken;
                    }
                    if (username !== undefined) {
                        localVarQueryParameter['username'] = username;
                    }
                    if (firstName !== undefined) {
                        localVarQueryParameter['firstName'] = firstName;
                    }
                    if (lastName !== undefined) {
                        localVarQueryParameter['lastName'] = lastName;
                    }
                    if (roles !== undefined) {
                        localVarQueryParameter['roles'] = roles;
                    }
                    if (createdAt !== undefined) {
                        localVarQueryParameter['createdAt'] = (createdAt instanceof Date) ?
                            createdAt.toISOString().substring(0, 10) :
                            createdAt;
                    }
                    if (createdAtFilterType !== undefined) {
                        localVarQueryParameter['createdAtFilterType'] = createdAtFilterType;
                    }
                    if (lastLogin !== undefined) {
                        localVarQueryParameter['lastLogin'] = (lastLogin instanceof Date) ?
                            lastLogin.toISOString().substring(0, 10) :
                            lastLogin;
                    }
                    if (lastLoginFilterType !== undefined) {
                        localVarQueryParameter['lastLoginFilterType'] = lastLoginFilterType;
                    }
                    if (enabled !== undefined) {
                        localVarQueryParameter['enabled'] = enabled;
                    }
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Reset the password of the selected users. The access token header should include the login token for the requesting user. If the requesting user is a reseller user managing customer users - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Reset password
         * @param {string} accessToken
         * @param {Array<string>} requestBody List of users to reset their password
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: function (accessToken_1, requestBody_1, targetOrgToken_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, requestBody_1, targetOrgToken_1], args_1, true), void 0, function (accessToken, requestBody, targetOrgToken, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('resetPassword', 'accessToken', accessToken);
                    // verify required parameter 'requestBody' is not null or undefined
                    (0, common_1.assertParamExists)('resetPassword', 'requestBody', requestBody);
                    localVarPath = "/api/v1/users/reset-password";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(requestBody, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Update user first and/or last name. The access token header should include the login token for the requesting user. If the requesting user is a reseller user updating a customer user - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Update user
         * @param {string} accessToken
         * @param {string} userId
         * @param {UpdateUserRequest} updateUserRequest
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: function (accessToken_1, userId_1, updateUserRequest_1, targetOrgToken_1) {
            var args_1 = [];
            for (var _i = 4; _i < arguments.length; _i++) {
                args_1[_i - 4] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, userId_1, updateUserRequest_1, targetOrgToken_1], args_1, true), void 0, function (accessToken, userId, updateUserRequest, targetOrgToken, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('updateUser', 'accessToken', accessToken);
                    // verify required parameter 'userId' is not null or undefined
                    (0, common_1.assertParamExists)('updateUser', 'userId', userId);
                    // verify required parameter 'updateUserRequest' is not null or undefined
                    (0, common_1.assertParamExists)('updateUser', 'updateUserRequest', updateUserRequest);
                    localVarPath = "/api/v1/users/{userId}"
                        .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateUserRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
        /**
         * Add existing roles to, remove roles from, and update the default role for the given users. The access token header should include the login token for the requesting user. If the requesting user is a reseller user managing customer users - include also the exchanged token for this customer in the targetOrgToken header. In this case all the roles are expected to be customer roles.
         * @summary Update users roles
         * @param {string} accessToken
         * @param {string} [targetOrgToken]
         * @param {UpdateUserRolesRequest} [updateUserRolesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserRoles: function (accessToken_1, targetOrgToken_1, updateUserRolesRequest_1) {
            var args_1 = [];
            for (var _i = 3; _i < arguments.length; _i++) {
                args_1[_i - 3] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([accessToken_1, targetOrgToken_1, updateUserRolesRequest_1], args_1, true), void 0, function (accessToken, targetOrgToken, updateUserRolesRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    // verify required parameter 'accessToken' is not null or undefined
                    (0, common_1.assertParamExists)('updateUserRoles', 'accessToken', accessToken);
                    localVarPath = "/api/v1/users/roles";
                    localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                    if (configuration) {
                        baseOptions = configuration.baseOptions;
                    }
                    localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                    localVarHeaderParameter = {};
                    localVarQueryParameter = {};
                    if (accessToken != null) {
                        localVarHeaderParameter['AccessToken'] = String(accessToken);
                    }
                    if (targetOrgToken != null) {
                        localVarHeaderParameter['TargetOrgToken'] = String(targetOrgToken);
                    }
                    localVarHeaderParameter['Content-Type'] = 'application/json';
                    (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                    headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                    localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                    localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateUserRolesRequest, localVarRequestOptions, configuration);
                    return [2 /*return*/, {
                            url: (0, common_1.toPathString)(localVarUrlObj),
                            options: localVarRequestOptions,
                        }];
                });
            });
        },
    };
};
exports.UsersServiceApiAxiosParamCreator = UsersServiceApiAxiosParamCreator;
/**
 * UsersServiceApi - functional programming interface
 * @export
 */
var UsersServiceApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.UsersServiceApiAxiosParamCreator)(configuration);
    return {
        /**
         * Create new users in a single realm in Keycloak. The access token header should include the login token for the requesting user. If the requesting user is a reseller user creating users for a customer - include also the exchanged token for this customer in the targetOrgToken header. **Note: creating a user does not set its roles.**
         * @summary Create users
         * @param {string} accessToken
         * @param {Array<User>} user
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUsers: function (accessToken, user, targetOrgToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createUsers(accessToken, user, targetOrgToken, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersServiceApi.createUsers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Batch delete users. The access token header should include the login token for the requesting user. If the requesting user is a reseller user deleting customer users - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Delete users
         * @param {string} accessToken
         * @param {Array<string>} requestBody
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUsers: function (accessToken, requestBody, targetOrgToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.deleteUsers(accessToken, requestBody, targetOrgToken, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersServiceApi.deleteUsers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Download all the users, or the selected users. The access token header should include the login token for the requesting user. If the requesting user is a reseller user downloading customer users - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Download users
         * @param {string} accessToken
         * @param {string} [targetOrgToken]
         * @param {string} [paginationToken] The token received in the previous response. if this is the first request - omit.
         * @param {number} [pageSize] Indicates how many entries to return. Must be a positive number. If omitted, a default page size will be used (configurable in properties).
         * @param {DownloadUsersRequest} [downloadUsersRequest] List of user ids to download. If empty or null - download all users that the requesting user is allowed to view
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadUsers: function (accessToken, targetOrgToken, paginationToken, pageSize, downloadUsersRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.downloadUsers(accessToken, targetOrgToken, paginationToken, pageSize, downloadUsersRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersServiceApi.downloadUsers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Batch enable or disable users. The access token header should include the login token for the requesting user. If the requesting user is a reseller user updating customer users - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Enable or Disable users
         * @param {string} accessToken
         * @param {boolean} enable true to enable, false to disable
         * @param {Array<string>} requestBody
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableUsers: function (accessToken, enable, requestBody, targetOrgToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.enableUsers(accessToken, enable, requestBody, targetOrgToken, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersServiceApi.enableUsers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get all the users, from all organizations, or filter by search string. Send pageSize = -1 to get ALL users. The access token header should include the login token for the requesting user. The requesting user should have system management permissions.
         * @summary Get all users from all organizations
         * @param {string} accessToken
         * @param {string} [search]
         * @param {number} [pageSize] Indicates how many entries to return. Must be a positive number. If omitted, a default page size will be used (configurable in properties).
         * @param {number} [offset]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsersInSystem: function (accessToken, search, pageSize, offset, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getAllUsersInSystem(accessToken, search, pageSize, offset, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersServiceApi.getAllUsersInSystem']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get partial permission details of a user for given category and action. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing permissions for a customer user - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Get partial permissions of user
         * @param {string} accessToken
         * @param {string} userId
         * @param {IEntityCategory} category
         * @param {IAction} action
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartialPermissionsOfUser: function (accessToken, userId, category, action, targetOrgToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getPartialPermissionsOfUser(accessToken, userId, category, action, targetOrgToken, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersServiceApi.getPartialPermissionsOfUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get the user details. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing a customer user - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Get user
         * @param {string} accessToken
         * @param {string} userId
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: function (accessToken, userId, targetOrgToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getUser(accessToken, userId, targetOrgToken, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersServiceApi.getUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Get all the users, or filter by search string. Send pageSize = -1 to get ALL users. The access token header should include the login token for the requesting user.If the requesting user is a reseller user viewing customer users - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Get all users
         * @param {string} accessToken
         * @param {string} [targetOrgToken]
         * @param {string} [search]
         * @param {number} [pageSize] Indicates how many entries to return. Must be a positive number. If omitted, a default page size will be used (configurable in properties).
         * @param {string} [paginationToken] The token received in the previous response. if this is the first request - omit.
         * @param {string} [username] Search expression to filter only by username
         * @param {string} [firstName] Search expression to filter only by first name
         * @param {string} [lastName] Search expression to filter only by last name
         * @param {string} [roles] Search expression to filter only by roles
         * @param {string} [createdAt] Search expression to filter only by creation date, format: yyyy-MM-dd
         * @param {DateFilterType} [createdAtFilterType] if createdAt filter is provided, this parameter indicates how to use it. If missing, server will use default - EQUALS
         * @param {string} [lastLogin] Search expression to filter only by last login date, format: yyyy-MM-dd
         * @param {DateFilterType} [lastLoginFilterType] if lastLogin filter is provided, this parameter indicates how to use it. If missing, server will use default - EQUALS
         * @param {boolean} [enabled] Search expression to filter only by enabled status: if true - return only enabled. If false - return only disabled. If omitted - return both
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: function (accessToken, targetOrgToken, search, pageSize, paginationToken, username, firstName, lastName, roles, createdAt, createdAtFilterType, lastLogin, lastLoginFilterType, enabled, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getUsers(accessToken, targetOrgToken, search, pageSize, paginationToken, username, firstName, lastName, roles, createdAt, createdAtFilterType, lastLogin, lastLoginFilterType, enabled, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersServiceApi.getUsers']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Reset the password of the selected users. The access token header should include the login token for the requesting user. If the requesting user is a reseller user managing customer users - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Reset password
         * @param {string} accessToken
         * @param {Array<string>} requestBody List of users to reset their password
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: function (accessToken, requestBody, targetOrgToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.resetPassword(accessToken, requestBody, targetOrgToken, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersServiceApi.resetPassword']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Update user first and/or last name. The access token header should include the login token for the requesting user. If the requesting user is a reseller user updating a customer user - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Update user
         * @param {string} accessToken
         * @param {string} userId
         * @param {UpdateUserRequest} updateUserRequest
         * @param {string} [targetOrgToken]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: function (accessToken, userId, updateUserRequest, targetOrgToken, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateUser(accessToken, userId, updateUserRequest, targetOrgToken, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersServiceApi.updateUser']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         * Add existing roles to, remove roles from, and update the default role for the given users. The access token header should include the login token for the requesting user. If the requesting user is a reseller user managing customer users - include also the exchanged token for this customer in the targetOrgToken header. In this case all the roles are expected to be customer roles.
         * @summary Update users roles
         * @param {string} accessToken
         * @param {string} [targetOrgToken]
         * @param {UpdateUserRolesRequest} [updateUserRolesRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserRoles: function (accessToken, targetOrgToken, updateUserRolesRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateUserRoles(accessToken, targetOrgToken, updateUserRolesRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['UsersServiceApi.updateUserRoles']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.UsersServiceApiFp = UsersServiceApiFp;
/**
 * UsersServiceApi - factory interface
 * @export
 */
var UsersServiceApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.UsersServiceApiFp)(configuration);
    return {
        /**
         * Create new users in a single realm in Keycloak. The access token header should include the login token for the requesting user. If the requesting user is a reseller user creating users for a customer - include also the exchanged token for this customer in the targetOrgToken header. **Note: creating a user does not set its roles.**
         * @summary Create users
         * @param {UsersServiceApiCreateUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUsers: function (requestParameters, options) {
            return localVarFp.createUsers(requestParameters.accessToken, requestParameters.user, requestParameters.targetOrgToken, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Batch delete users. The access token header should include the login token for the requesting user. If the requesting user is a reseller user deleting customer users - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Delete users
         * @param {UsersServiceApiDeleteUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUsers: function (requestParameters, options) {
            return localVarFp.deleteUsers(requestParameters.accessToken, requestParameters.requestBody, requestParameters.targetOrgToken, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Download all the users, or the selected users. The access token header should include the login token for the requesting user. If the requesting user is a reseller user downloading customer users - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Download users
         * @param {UsersServiceApiDownloadUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        downloadUsers: function (requestParameters, options) {
            return localVarFp.downloadUsers(requestParameters.accessToken, requestParameters.targetOrgToken, requestParameters.paginationToken, requestParameters.pageSize, requestParameters.downloadUsersRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Batch enable or disable users. The access token header should include the login token for the requesting user. If the requesting user is a reseller user updating customer users - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Enable or Disable users
         * @param {UsersServiceApiEnableUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        enableUsers: function (requestParameters, options) {
            return localVarFp.enableUsers(requestParameters.accessToken, requestParameters.enable, requestParameters.requestBody, requestParameters.targetOrgToken, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all the users, from all organizations, or filter by search string. Send pageSize = -1 to get ALL users. The access token header should include the login token for the requesting user. The requesting user should have system management permissions.
         * @summary Get all users from all organizations
         * @param {UsersServiceApiGetAllUsersInSystemRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsersInSystem: function (requestParameters, options) {
            return localVarFp.getAllUsersInSystem(requestParameters.accessToken, requestParameters.search, requestParameters.pageSize, requestParameters.offset, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get partial permission details of a user for given category and action. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing permissions for a customer user - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Get partial permissions of user
         * @param {UsersServiceApiGetPartialPermissionsOfUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPartialPermissionsOfUser: function (requestParameters, options) {
            return localVarFp.getPartialPermissionsOfUser(requestParameters.accessToken, requestParameters.userId, requestParameters.category, requestParameters.action, requestParameters.targetOrgToken, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get the user details. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing a customer user - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Get user
         * @param {UsersServiceApiGetUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUser: function (requestParameters, options) {
            return localVarFp.getUser(requestParameters.accessToken, requestParameters.userId, requestParameters.targetOrgToken, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Get all the users, or filter by search string. Send pageSize = -1 to get ALL users. The access token header should include the login token for the requesting user.If the requesting user is a reseller user viewing customer users - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Get all users
         * @param {UsersServiceApiGetUsersRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsers: function (requestParameters, options) {
            return localVarFp.getUsers(requestParameters.accessToken, requestParameters.targetOrgToken, requestParameters.search, requestParameters.pageSize, requestParameters.paginationToken, requestParameters.username, requestParameters.firstName, requestParameters.lastName, requestParameters.roles, requestParameters.createdAt, requestParameters.createdAtFilterType, requestParameters.lastLogin, requestParameters.lastLoginFilterType, requestParameters.enabled, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Reset the password of the selected users. The access token header should include the login token for the requesting user. If the requesting user is a reseller user managing customer users - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Reset password
         * @param {UsersServiceApiResetPasswordRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: function (requestParameters, options) {
            return localVarFp.resetPassword(requestParameters.accessToken, requestParameters.requestBody, requestParameters.targetOrgToken, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Update user first and/or last name. The access token header should include the login token for the requesting user. If the requesting user is a reseller user updating a customer user - include also the exchanged token for this customer in the targetOrgToken header.
         * @summary Update user
         * @param {UsersServiceApiUpdateUserRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUser: function (requestParameters, options) {
            return localVarFp.updateUser(requestParameters.accessToken, requestParameters.userId, requestParameters.updateUserRequest, requestParameters.targetOrgToken, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         * Add existing roles to, remove roles from, and update the default role for the given users. The access token header should include the login token for the requesting user. If the requesting user is a reseller user managing customer users - include also the exchanged token for this customer in the targetOrgToken header. In this case all the roles are expected to be customer roles.
         * @summary Update users roles
         * @param {UsersServiceApiUpdateUserRolesRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserRoles: function (requestParameters, options) {
            return localVarFp.updateUserRoles(requestParameters.accessToken, requestParameters.targetOrgToken, requestParameters.updateUserRolesRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.UsersServiceApiFactory = UsersServiceApiFactory;
/**
 * UsersServiceApi - object-oriented interface
 * @export
 * @class UsersServiceApi
 * @extends {BaseAPI}
 */
var UsersServiceApi = /** @class */ (function (_super) {
    __extends(UsersServiceApi, _super);
    function UsersServiceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create new users in a single realm in Keycloak. The access token header should include the login token for the requesting user. If the requesting user is a reseller user creating users for a customer - include also the exchanged token for this customer in the targetOrgToken header. **Note: creating a user does not set its roles.**
     * @summary Create users
     * @param {UsersServiceApiCreateUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersServiceApi
     */
    UsersServiceApi.prototype.createUsers = function (requestParameters, options) {
        var _this = this;
        return (0, exports.UsersServiceApiFp)(this.configuration).createUsers(requestParameters.accessToken, requestParameters.user, requestParameters.targetOrgToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Batch delete users. The access token header should include the login token for the requesting user. If the requesting user is a reseller user deleting customer users - include also the exchanged token for this customer in the targetOrgToken header.
     * @summary Delete users
     * @param {UsersServiceApiDeleteUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersServiceApi
     */
    UsersServiceApi.prototype.deleteUsers = function (requestParameters, options) {
        var _this = this;
        return (0, exports.UsersServiceApiFp)(this.configuration).deleteUsers(requestParameters.accessToken, requestParameters.requestBody, requestParameters.targetOrgToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Download all the users, or the selected users. The access token header should include the login token for the requesting user. If the requesting user is a reseller user downloading customer users - include also the exchanged token for this customer in the targetOrgToken header.
     * @summary Download users
     * @param {UsersServiceApiDownloadUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersServiceApi
     */
    UsersServiceApi.prototype.downloadUsers = function (requestParameters, options) {
        var _this = this;
        return (0, exports.UsersServiceApiFp)(this.configuration).downloadUsers(requestParameters.accessToken, requestParameters.targetOrgToken, requestParameters.paginationToken, requestParameters.pageSize, requestParameters.downloadUsersRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Batch enable or disable users. The access token header should include the login token for the requesting user. If the requesting user is a reseller user updating customer users - include also the exchanged token for this customer in the targetOrgToken header.
     * @summary Enable or Disable users
     * @param {UsersServiceApiEnableUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersServiceApi
     */
    UsersServiceApi.prototype.enableUsers = function (requestParameters, options) {
        var _this = this;
        return (0, exports.UsersServiceApiFp)(this.configuration).enableUsers(requestParameters.accessToken, requestParameters.enable, requestParameters.requestBody, requestParameters.targetOrgToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all the users, from all organizations, or filter by search string. Send pageSize = -1 to get ALL users. The access token header should include the login token for the requesting user. The requesting user should have system management permissions.
     * @summary Get all users from all organizations
     * @param {UsersServiceApiGetAllUsersInSystemRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersServiceApi
     */
    UsersServiceApi.prototype.getAllUsersInSystem = function (requestParameters, options) {
        var _this = this;
        return (0, exports.UsersServiceApiFp)(this.configuration).getAllUsersInSystem(requestParameters.accessToken, requestParameters.search, requestParameters.pageSize, requestParameters.offset, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get partial permission details of a user for given category and action. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing permissions for a customer user - include also the exchanged token for this customer in the targetOrgToken header.
     * @summary Get partial permissions of user
     * @param {UsersServiceApiGetPartialPermissionsOfUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersServiceApi
     */
    UsersServiceApi.prototype.getPartialPermissionsOfUser = function (requestParameters, options) {
        var _this = this;
        return (0, exports.UsersServiceApiFp)(this.configuration).getPartialPermissionsOfUser(requestParameters.accessToken, requestParameters.userId, requestParameters.category, requestParameters.action, requestParameters.targetOrgToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get the user details. The access token header should include the login token for the requesting user. If the requesting user is a reseller user viewing a customer user - include also the exchanged token for this customer in the targetOrgToken header.
     * @summary Get user
     * @param {UsersServiceApiGetUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersServiceApi
     */
    UsersServiceApi.prototype.getUser = function (requestParameters, options) {
        var _this = this;
        return (0, exports.UsersServiceApiFp)(this.configuration).getUser(requestParameters.accessToken, requestParameters.userId, requestParameters.targetOrgToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Get all the users, or filter by search string. Send pageSize = -1 to get ALL users. The access token header should include the login token for the requesting user.If the requesting user is a reseller user viewing customer users - include also the exchanged token for this customer in the targetOrgToken header.
     * @summary Get all users
     * @param {UsersServiceApiGetUsersRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersServiceApi
     */
    UsersServiceApi.prototype.getUsers = function (requestParameters, options) {
        var _this = this;
        return (0, exports.UsersServiceApiFp)(this.configuration).getUsers(requestParameters.accessToken, requestParameters.targetOrgToken, requestParameters.search, requestParameters.pageSize, requestParameters.paginationToken, requestParameters.username, requestParameters.firstName, requestParameters.lastName, requestParameters.roles, requestParameters.createdAt, requestParameters.createdAtFilterType, requestParameters.lastLogin, requestParameters.lastLoginFilterType, requestParameters.enabled, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Reset the password of the selected users. The access token header should include the login token for the requesting user. If the requesting user is a reseller user managing customer users - include also the exchanged token for this customer in the targetOrgToken header.
     * @summary Reset password
     * @param {UsersServiceApiResetPasswordRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersServiceApi
     */
    UsersServiceApi.prototype.resetPassword = function (requestParameters, options) {
        var _this = this;
        return (0, exports.UsersServiceApiFp)(this.configuration).resetPassword(requestParameters.accessToken, requestParameters.requestBody, requestParameters.targetOrgToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Update user first and/or last name. The access token header should include the login token for the requesting user. If the requesting user is a reseller user updating a customer user - include also the exchanged token for this customer in the targetOrgToken header.
     * @summary Update user
     * @param {UsersServiceApiUpdateUserRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersServiceApi
     */
    UsersServiceApi.prototype.updateUser = function (requestParameters, options) {
        var _this = this;
        return (0, exports.UsersServiceApiFp)(this.configuration).updateUser(requestParameters.accessToken, requestParameters.userId, requestParameters.updateUserRequest, requestParameters.targetOrgToken, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     * Add existing roles to, remove roles from, and update the default role for the given users. The access token header should include the login token for the requesting user. If the requesting user is a reseller user managing customer users - include also the exchanged token for this customer in the targetOrgToken header. In this case all the roles are expected to be customer roles.
     * @summary Update users roles
     * @param {UsersServiceApiUpdateUserRolesRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UsersServiceApi
     */
    UsersServiceApi.prototype.updateUserRoles = function (requestParameters, options) {
        var _this = this;
        return (0, exports.UsersServiceApiFp)(this.configuration).updateUserRoles(requestParameters.accessToken, requestParameters.targetOrgToken, requestParameters.updateUserRolesRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return UsersServiceApi;
}(base_1.BaseAPI));
exports.UsersServiceApi = UsersServiceApi;
